var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _rect, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLotG(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2984,
    height: 2401,
    viewBox: "0 0 2984 2401",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M284 1358.98L309.5 1424.98L339.5 1500.98L1272 1137.48L1214.5 992.977L284 1358.98Z",
    fill: "#6CDD59"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M390 1610.98L415.5 1676.98L445.5 1752.98L1378 1389.48L1320.5 1244.98L390 1610.98Z",
    fill: "#6CDD59"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1353 1230.98L1378.5 1296.98L1408.5 1372.98L2528.5 929.477L2479 782.477L1353 1230.98Z",
    fill: "#6CDD59"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M543.5 1835.98L572.5 1896.48L699.5 1936.48L2631 1178.48L2573.5 1033.98L543.5 1835.98Z",
    fill: "#6CDD59"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1071.5 1912.98H1088.5L1115 1961.48L2810 1306.48L2785.5 1239.48L1071.5 1912.98Z",
    fill: "#6CDD59"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1388 929.977L1413.5 995.977L1443.5 1071.98L2435.5 681.977L2380.5 538.477L1388 929.977Z",
    fill: "#6CDD59"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2329 67.9766L1270 491.477L1294.5 557.477L2362 155.977L2329 67.9766Z",
    fill: "#6CDD59"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1292 682.977L1317.5 748.977L1347.5 824.977L2339.5 434.977L2284.5 291.477L1292 682.977Z",
    fill: "#6CDD59"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1146.5 813.477L453.5 1089.48L481.5 1163.48L1179.5 896.977L1146.5 813.477Z",
    fill: "#6CDD59"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M207.5 1505.98L143.5 1531.48L349 2054.98L413 2029.98L207.5 1505.98Z",
    fill: "#6CDD59"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M2441.5 142.477L2374.5 172.977L2790 1229.48L2863 1202.98L2441.5 142.477Z",
    fill: "#6CDD59"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1205 1079.98L1139.5 1104.98L1168.5 1177.98L1234 1152.48L1205 1079.98Z",
    fill: "#FF5910"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M2577 1032.98L2436.5 1088.98L2496.5 1232.98L2631.5 1180.98L2577 1032.98Z",
    fill: "#E13827"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M2180 616.977L2045 669.977L2105 813.977L2240 761.977L2180 616.977Z",
    fill: "#E13827"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1716 511.977L1558.5 577.977L1613 720.977L1776 656.977L1716 511.977Z",
    fill: "#E13827"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1245.87 447.014C1236.22 450.966 1230.67 453.358 1229.25 454.139C1225.78 456.045 1222.26 457.829 1218.88 459.55L1218.73 459.626C1215.27 461.383 1211.95 463.073 1208.78 464.826C1202.42 468.345 1197 471.945 1192.9 476.333C1188.89 480.632 1186.09 485.754 1185.05 492.52C1184 499.385 1184.73 508.233 1188.33 519.969C1195.56 543.532 1206.43 558.351 1215.33 567.228C1219.79 571.677 1223.78 574.655 1226.6 576.498C1227.65 577.183 1228.54 577.711 1229.23 578.1L1284.46 556.513L1254.69 480.353L2335.42 53.8294L2377.78 162.196L2447.44 126.522L2911.95 1304.49L2883.9 1368.63L554.449 2283.18L512.599 2165.64L390.282 2213.45L386.81 2204.56L518.277 2153.18L560.121 2270.71L2876.75 1361.19L2901.63 1304.29L2442.43 139.801L2372.74 175.489L2330.03 66.2105L1267.03 485.738L1296.8 561.929L1228.86 588.485L1227.05 587.692L1228.96 583.325C1227.05 587.692 1227.05 587.691 1227.05 587.689L1227.04 587.687L1227.03 587.68L1226.99 587.664L1226.88 587.616C1226.8 587.577 1226.68 587.524 1226.54 587.456C1226.26 587.32 1225.87 587.125 1225.39 586.865C1224.42 586.345 1223.06 585.566 1221.4 584.483C1218.08 582.318 1213.58 578.935 1208.61 573.981C1198.65 564.052 1186.93 547.89 1179.22 522.762C1175.35 510.152 1174.3 499.793 1175.63 491.069C1176.98 482.245 1180.73 475.397 1185.94 469.821C1191.06 464.336 1197.51 460.159 1204.17 456.479C1207.5 454.632 1210.98 452.866 1214.41 451.122L1214.5 451.075C1217.93 449.334 1221.32 447.609 1224.66 445.776C1226.69 444.665 1232.9 442.02 1242.26 438.188C1251.78 434.286 1264.94 429.013 1281.17 422.574C1313.65 409.694 1358.54 392.125 1411.61 371.473C1517.75 330.166 1656.69 276.512 1794.76 223.333C1932.83 170.153 2070.04 117.446 2172.73 78.0339C2224.08 58.3279 2266.8 41.9458 2296.68 30.49C2311.62 24.7622 2323.35 20.266 2331.34 17.2017L2343.55 12.5239L2343.57 12.5149L2343.6 12.5048L2343.67 12.4792L2343.91 12.3868C2344.12 12.3076 2344.42 12.194 2344.81 12.0501C2345.6 11.7624 2346.74 11.3541 2348.2 10.8604C2351.11 9.87323 2355.28 8.54262 2360.38 7.15174C2370.55 4.37579 2384.48 1.33125 2399.42 0.3337C2428.97 -1.64002 2464.48 4.37632 2480.31 39.1812C2494.93 71.3133 2610.61 372.697 2722.51 665.705C2778.48 812.285 2833.55 956.867 2874.63 1064.8C2895.17 1118.77 2912.21 1163.58 2924.11 1194.9C2930.06 1210.55 2934.73 1222.84 2937.91 1231.21L2942.63 1243.63L2942.64 1243.65C2942.8 1243.91 2943.03 1244.29 2943.32 1244.79C2943.91 1245.79 2944.76 1247.25 2945.82 1249.11C2947.92 1252.83 2950.85 1258.18 2954.15 1264.7C2960.75 1277.71 2968.89 1295.5 2974.95 1314.42C2980.99 1333.27 2985.11 1353.66 2983.3 1371.75C2981.46 1390.06 2973.47 1406.34 2955.19 1415.76C2946.63 1420.19 2903.31 1438.11 2834.56 1465.9C2765.6 1493.77 2670.7 1531.71 2558.7 1576.27C2334.68 1665.4 2042.2 1781.02 1751.79 1895.56C1461.38 2010.11 1173.04 2123.58 957.297 2208.41C849.427 2250.83 759.707 2286.09 696.954 2310.75C665.578 2323.07 640.944 2332.75 624.154 2339.34L598.443 2349.44C598.426 2349.45 598.417 2349.45 596.674 2345.01C594.931 2340.57 594.94 2340.57 594.957 2340.56L620.667 2330.47C637.457 2323.87 662.091 2314.2 693.467 2301.87C756.218 2277.21 845.937 2241.96 953.807 2199.54C1169.55 2114.7 1457.89 2001.23 1748.29 1886.69C2038.7 1772.15 2331.17 1656.53 2555.17 1567.41C2667.17 1522.85 2762.05 1484.92 2830.99 1457.05C2900.11 1429.11 2942.81 1411.43 2950.81 1407.28L2950.83 1407.28C2965.54 1399.7 2972.22 1386.76 2973.82 1370.8C2975.44 1354.61 2971.76 1335.68 2965.88 1317.33C2960.03 1299.06 2952.12 1281.76 2945.66 1269.01C2942.43 1262.64 2939.57 1257.42 2937.52 1253.8C2936.5 1251.99 2935.68 1250.59 2935.12 1249.64C2934.84 1249.16 2934.62 1248.8 2934.48 1248.56L2934.28 1248.23L2934.27 1248.22L2934.27 1248.21L2934.04 1247.83L2933.88 1247.42L2938.33 1245.73C2933.88 1247.42 2933.88 1247.41 2933.87 1247.4L2933.86 1247.36L2929.01 1234.59C2925.83 1226.22 2921.16 1213.94 2915.21 1198.28C2903.3 1166.97 2886.26 1122.16 2865.72 1068.19C2824.65 960.257 2769.58 815.679 2713.6 669.104C2601.59 375.803 2486.09 74.9011 2471.64 43.127C2458.4 14.0257 2428.58 7.94405 2400.06 9.84901C2385.96 10.7907 2372.68 13.6796 2362.89 16.3522C2358.01 17.6856 2354.02 18.9581 2351.26 19.893C2349.88 20.3603 2348.81 20.7428 2348.09 21.0056C2347.74 21.1371 2347.46 21.2386 2347.29 21.3057L2347.09 21.3802L2347.05 21.3971L2347.04 21.4002L2347.01 21.4116L2345.31 16.9582C2347.01 21.4115 2347.01 21.4132 2347 21.4163L2334.76 26.1078C2326.76 29.172 2315.03 33.6682 2300.09 39.3958C2270.21 50.8512 2227.5 67.233 2176.15 86.9384C2073.46 126.349 1936.26 179.055 1798.19 232.233C1660.12 285.412 1521.2 339.061 1415.07 380.361C1362 401.012 1317.14 418.572 1284.69 431.44C1268.46 437.875 1255.35 443.132 1245.87 447.014Z",
    fill: "#9C9C9C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M610.218 2163.85L500.442 2206.75L498.699 2202.29L612.98 2157.63L643.85 2239.3L639.376 2240.99L610.218 2163.85Z",
    fill: "#9C9C9C"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2385.18 159.816L2333.33 25.1937L2343.29 21.3572L2395.14 155.98L2385.18 159.816Z",
    fill: "#9C9C9C"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2459.65 29.2066L2342.41 71.4435L2338.79 61.3896L2456.02 19.1528L2459.65 29.2066Z",
    fill: "#9C9C9C"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2489.16 79.8335L2363.49 125.365L2359.72 114.958L2485.38 69.4261L2489.16 79.8335Z",
    fill: "#9C9C9C"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2478.04 51.4064L2352.38 96.938L2348.61 86.5307L2474.27 40.9991L2478.04 51.4064Z",
    fill: "#9C9C9C"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2501.22 110.704L2375.55 156.235L2371.78 145.828L2497.45 100.296L2501.22 110.704Z",
    fill: "#9C9C9C"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2515.63 147.245L2383.42 197.637L2381.56 192.764L2513.77 142.373L2515.63 147.245Z",
    fill: "#9C9C9C"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2528.39 179.892L2396.18 230.284L2394.32 225.411L2526.53 175.02L2528.39 179.892Z",
    fill: "#9C9C9C"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2542.62 216.316L2410.32 266.485L2408.48 261.61L2540.77 211.44L2542.62 216.316Z",
    fill: "#9C9C9C"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2555.38 248.962L2423.08 299.132L2421.24 294.256L2553.53 244.087L2555.38 248.962Z",
    fill: "#9C9C9C"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2567.19 279.165L2434.98 329.556L2433.12 324.684L2565.33 274.292L2567.19 279.165Z",
    fill: "#9C9C9C"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2579.95 311.811L2447.74 362.203L2445.88 357.331L2578.09 306.939L2579.95 311.811Z",
    fill: "#9C9C9C"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2594.18 348.235L2461.88 398.405L2460.04 393.529L2592.33 343.36L2594.18 348.235Z",
    fill: "#9C9C9C"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2606.94 380.882L2474.64 431.051L2472.79 426.176L2605.09 376.006L2606.94 380.882Z",
    fill: "#9C9C9C"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2620.14 414.637L2487.93 465.029L2486.07 460.157L2618.28 409.765L2620.14 414.637Z",
    fill: "#9C9C9C"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2632.89 447.284L2500.69 497.676L2498.83 492.803L2631.04 442.412L2632.89 447.284Z",
    fill: "#9C9C9C"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2647.13 483.708L2514.83 533.877L2512.98 529.002L2645.28 478.832L2647.13 483.708Z",
    fill: "#9C9C9C"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2659.89 516.355L2527.59 566.524L2525.74 561.649L2658.04 511.479L2659.89 516.355Z",
    fill: "#9C9C9C"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2671.69 546.557L2539.49 596.948L2537.63 592.076L2669.84 541.684L2671.69 546.557Z",
    fill: "#9C9C9C"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2684.45 579.204L2552.25 629.595L2550.39 624.723L2682.6 574.331L2684.45 579.204Z",
    fill: "#9C9C9C"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2698.69 615.627L2566.39 665.797L2564.54 660.921L2696.84 610.752L2698.69 615.627Z",
    fill: "#9C9C9C"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2711.44 648.274L2579.15 698.443L2577.3 693.568L2709.6 643.398L2711.44 648.274Z",
    fill: "#9C9C9C"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2725.6 684.472L2593.39 734.864L2591.53 729.992L2723.74 679.6L2725.6 684.472Z",
    fill: "#9C9C9C"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2739.83 720.896L2607.54 771.066L2605.69 766.19L2737.98 716.021L2739.83 720.896Z",
    fill: "#9C9C9C"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2752.59 753.543L2620.3 803.712L2618.45 798.837L2750.74 748.667L2752.59 753.543Z",
    fill: "#9C9C9C"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2764.4 783.745L2632.19 834.137L2630.33 829.264L2762.54 778.873L2764.4 783.745Z",
    fill: "#9C9C9C"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2777.16 816.392L2644.95 866.783L2643.09 861.911L2775.3 811.519L2777.16 816.392Z",
    fill: "#9C9C9C"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2791.39 852.816L2659.09 902.985L2657.25 898.11L2789.54 847.94L2791.39 852.816Z",
    fill: "#9C9C9C"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2804.15 885.462L2671.85 935.632L2670.01 930.756L2802.3 880.587L2804.15 885.462Z",
    fill: "#9C9C9C"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2817.35 919.218L2685.14 969.609L2683.28 964.737L2815.49 914.346L2817.35 919.218Z",
    fill: "#9C9C9C"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2830.1 951.865L2697.9 1002.26L2696.04 997.384L2828.25 946.992L2830.1 951.865Z",
    fill: "#9C9C9C"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2844.34 988.289L2712.04 1038.46L2710.19 1033.58L2842.49 983.413L2844.34 988.289Z",
    fill: "#9C9C9C"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2857.1 1020.93L2724.89 1071.33L2723.04 1066.45L2855.24 1016.06L2857.1 1020.93Z",
    fill: "#9C9C9C"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2868.9 1051.14L2736.7 1101.53L2734.84 1096.66L2867.05 1046.26L2868.9 1051.14Z",
    fill: "#9C9C9C"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2881.66 1083.78L2749.46 1134.18L2747.6 1129.3L2879.81 1078.91L2881.66 1083.78Z",
    fill: "#9C9C9C"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2895.9 1120.21L2763.6 1170.38L2761.75 1165.5L2894.05 1115.33L2895.9 1120.21Z",
    fill: "#9C9C9C"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2908.66 1152.85L2776.45 1203.24L2774.6 1198.37L2906.8 1147.98L2908.66 1152.85Z",
    fill: "#9C9C9C"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M2866.03 1200.76L2777.3 1235.44L2807.77 1313.4L2896.5 1278.72L2866.03 1200.76Z",
    fill: "#9C9C9C"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1278.54 561.089L1233.95 444.369L1243.35 440.776L1287.95 557.496L1278.54 561.089Z",
    fill: "#9C9C9C"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2417.28 14.4624L1185.63 513.506L1181.84 504.166L2413.49 5.1226L2417.28 14.4624Z",
    fill: "#9C9C9C"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1280.06 544.437L1209.01 569.393L1205.67 559.885L1276.72 534.93L1280.06 544.437Z",
    fill: "#9C9C9C"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1268.69 515.344L1197.64 540.299L1194.3 530.792L1265.35 505.836L1268.69 515.344Z",
    fill: "#9C9C9C"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M1291.95 484.72C1307.26 478.735 1314.82 461.454 1308.83 446.122C1302.83 430.79 1285.56 423.213 1270.25 429.199C1254.93 435.185 1247.37 452.466 1253.37 467.798C1259.36 483.129 1276.63 490.706 1291.95 484.72Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1271.21 431.658C1257.25 437.114 1250.36 452.864 1255.82 466.837C1261.28 480.811 1277.03 487.716 1290.98 482.261C1304.94 476.805 1311.83 461.055 1306.37 447.082C1300.91 433.109 1285.16 426.203 1271.21 431.658ZM1250.91 468.758C1244.39 452.068 1252.61 433.255 1269.28 426.739C1285.96 420.223 1304.76 428.471 1311.28 445.161C1317.81 461.852 1309.58 480.664 1292.91 487.18C1276.24 493.696 1257.43 485.448 1250.91 468.758Z",
    fill: "#9C9C9C"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M1088.42 635.949C1103.74 629.964 1111.29 612.682 1105.3 597.351C1099.31 582.019 1082.04 574.442 1066.72 580.428C1051.41 586.413 1043.85 603.695 1049.84 619.026C1055.83 634.358 1073.11 641.935 1088.42 635.949Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1067.68 582.887C1053.72 588.343 1046.84 604.093 1052.3 618.066C1057.76 632.04 1073.5 638.945 1087.46 633.49C1101.42 628.034 1108.31 612.284 1102.84 598.311C1097.38 584.337 1081.64 577.432 1067.68 582.887ZM1047.38 619.987C1040.86 603.296 1049.09 584.484 1065.76 577.968C1082.43 571.452 1101.23 579.7 1107.76 596.39C1114.28 613.081 1106.05 631.893 1089.38 638.409C1072.71 644.925 1053.91 636.677 1047.38 619.987Z",
    fill: "#9C9C9C"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M1054.88 573.024C1070.19 567.039 1077.75 549.757 1071.76 534.425C1065.76 519.094 1048.49 511.517 1033.18 517.503C1017.86 523.488 1010.3 540.77 1016.3 556.101C1022.29 571.433 1039.56 579.01 1054.88 573.024Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1034.14 519.962C1020.18 525.418 1013.29 541.168 1018.75 555.141C1024.22 569.114 1039.96 576.02 1053.92 570.565C1067.87 565.109 1074.76 549.359 1069.3 535.386C1063.84 521.412 1048.1 514.507 1034.14 519.962ZM1013.84 557.062C1007.32 540.371 1015.54 521.559 1032.22 515.043C1048.89 508.527 1067.69 516.775 1074.21 533.465C1080.74 550.156 1072.51 568.968 1055.84 575.484C1039.17 582 1020.36 573.752 1013.84 557.062Z",
    fill: "#9C9C9C"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M963.691 609.943C979.006 603.958 986.564 586.676 980.571 571.344C974.579 556.013 957.306 548.436 941.991 554.422C926.677 560.407 919.119 577.689 925.112 593.02C931.104 608.352 948.377 615.929 963.691 609.943Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M942.953 556.881C928.995 562.337 922.107 578.087 927.568 592.06C933.03 606.034 948.772 612.939 962.73 607.484C976.688 602.028 983.576 586.278 978.114 572.305C972.653 558.331 956.911 551.426 942.953 556.881ZM922.655 593.981C916.131 577.29 924.358 558.478 941.03 551.962C957.702 545.446 976.505 553.694 983.028 570.384C989.551 587.075 981.325 605.887 964.653 612.403C947.981 618.919 929.178 610.671 922.655 593.981Z",
    fill: "#9C9C9C"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M866.758 646.549C882.072 640.563 889.63 623.282 883.637 607.95C877.645 592.618 860.372 585.042 845.057 591.027C829.743 597.013 822.185 614.294 828.178 629.626C834.17 644.958 851.443 652.535 866.758 646.549Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M846.019 593.487C832.061 598.942 825.173 614.692 830.635 628.666C836.096 642.639 851.838 649.544 865.796 644.089C879.754 638.634 886.642 622.884 881.18 608.91C875.719 594.937 859.977 588.032 846.019 593.487ZM825.721 630.586C819.197 613.896 827.424 595.084 844.096 588.568C860.768 582.051 879.571 590.299 886.094 606.99C892.618 623.68 884.391 642.493 867.719 649.009C851.047 655.525 832.244 647.277 825.721 630.586Z",
    fill: "#9C9C9C"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M775.572 683.468C790.887 677.482 798.444 660.201 792.452 644.869C786.46 629.537 769.187 621.961 753.872 627.946C738.557 633.932 731 651.213 736.992 666.545C742.985 681.877 760.257 689.454 775.572 683.468Z",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M754.833 630.406C740.875 635.861 733.988 651.611 739.449 665.585C744.91 679.558 760.653 686.464 774.611 681.008C788.568 675.553 795.456 659.803 789.995 645.829C784.534 631.856 768.791 624.951 754.833 630.406ZM734.535 667.505C728.012 650.815 736.239 632.003 752.911 625.487C769.582 618.971 788.386 627.219 794.909 643.909C801.432 660.599 793.205 679.412 776.533 685.928C759.862 692.444 741.058 684.196 734.535 667.505Z",
    fill: "#9C9C9C"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M692.759 713.019C707.706 707.177 715.082 690.31 709.233 675.346C703.385 660.382 686.527 652.987 671.579 658.829C656.632 664.671 649.256 681.538 655.105 696.502C660.953 711.466 677.812 718.861 692.759 713.019Z",
    fill: "white"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M672.519 661.234C658.898 666.557 652.177 681.927 657.506 695.563C662.836 709.199 678.198 715.938 691.819 710.614C705.44 705.291 712.161 689.921 706.832 676.285C701.502 662.649 686.14 655.91 672.519 661.234ZM652.703 697.441C646.335 681.149 654.366 662.785 670.64 656.425C686.913 650.065 705.268 658.116 711.635 674.407C718.003 690.699 709.972 709.063 693.698 715.423C677.425 721.783 659.07 713.732 652.703 697.441Z",
    fill: "#9C9C9C"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M511.545 785.892C526.492 780.05 533.868 763.184 528.02 748.22C522.171 733.256 505.313 725.861 490.366 731.703C475.419 737.545 468.043 754.412 473.891 769.376C479.74 784.339 496.598 791.734 511.545 785.892Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M491.306 734.108C477.685 739.431 470.963 754.801 476.293 768.437C481.622 782.073 496.985 788.811 510.605 783.488C524.226 778.164 530.948 762.795 525.618 749.159C520.289 735.523 504.926 728.784 491.306 734.108ZM471.489 770.314C465.122 754.022 473.153 735.659 489.426 729.299C505.7 722.938 524.054 730.989 530.422 747.281C536.789 763.573 528.759 781.936 512.485 788.297C496.211 794.657 477.857 786.606 471.489 770.314Z",
    fill: "#9C9C9C"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M603.936 747.478C618.884 741.636 626.26 724.77 620.411 709.806C614.563 694.842 597.704 687.447 582.757 693.289C567.81 699.131 560.434 715.997 566.282 730.961C572.131 745.925 588.989 753.32 603.936 747.478Z",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M583.697 695.693C570.076 701.017 563.355 716.387 568.684 730.023C574.014 743.658 589.376 750.397 602.997 745.074C616.617 739.75 623.339 724.38 618.009 710.744C612.68 697.108 597.318 690.37 583.697 695.693ZM563.881 731.9C557.513 715.608 565.544 697.245 581.817 690.884C598.091 684.524 616.445 692.575 622.813 708.867C629.18 725.159 621.15 743.522 604.876 749.882C588.602 756.243 570.248 748.192 563.881 731.9Z",
    fill: "#9C9C9C"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M443.922 848.42C458.869 842.578 466.245 825.711 460.397 810.747C454.548 795.783 437.69 788.389 422.743 794.231C407.796 800.073 400.42 816.939 406.268 831.903C412.117 846.867 428.975 854.262 443.922 848.42Z",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M423.683 796.635C410.062 801.959 403.34 817.328 408.67 830.964C413.999 844.6 429.362 851.339 442.982 846.015C456.603 840.692 463.325 825.322 457.995 811.686C452.666 798.05 437.303 791.312 423.683 796.635ZM403.866 832.842C397.499 816.55 405.529 798.187 421.803 791.826C438.077 785.466 456.431 793.517 462.799 809.809C469.166 826.1 461.136 844.464 444.862 850.824C428.588 857.185 410.234 849.134 403.866 832.842Z",
    fill: "#9C9C9C"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M372.962 913.532C387.909 907.69 395.285 890.823 389.436 875.859C383.588 860.895 366.73 853.501 351.782 859.343C336.835 865.185 329.459 882.051 335.308 897.015C341.156 911.979 358.014 919.374 372.962 913.532Z",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M352.722 861.747C339.101 867.071 332.38 882.44 337.709 896.076C343.039 909.712 358.401 916.451 372.022 911.127C385.643 905.804 392.364 890.434 387.035 876.798C381.705 863.162 366.343 856.423 352.722 861.747ZM332.906 897.954C326.538 881.662 334.569 863.299 350.843 856.938C367.116 850.578 385.471 858.629 391.838 874.921C398.206 891.212 390.175 909.576 373.901 915.936C357.628 922.297 339.273 914.245 332.906 897.954Z",
    fill: "#9C9C9C"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M300.603 976.374C315.55 970.532 322.926 953.666 317.078 938.702C311.229 923.738 294.371 916.343 279.424 922.185C264.476 928.027 257.1 944.893 262.949 959.857C268.797 974.821 285.656 982.216 300.603 976.374Z",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M280.363 924.589C266.742 929.913 260.021 945.283 265.351 958.919C270.68 972.555 286.042 979.293 299.663 973.97C313.284 968.646 320.005 953.276 314.676 939.64C309.346 926.004 293.984 919.266 280.363 924.589ZM260.547 960.796C254.18 944.504 262.21 926.141 278.484 919.781C294.757 913.42 313.112 921.471 319.479 937.763C325.847 954.055 317.816 972.418 301.543 978.778C285.269 985.139 266.915 977.088 260.547 960.796Z",
    fill: "#9C9C9C"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M227.356 1051.34C242.304 1045.5 249.679 1028.63 243.831 1013.67C237.982 998.704 221.124 991.309 206.177 997.151C191.23 1002.99 183.854 1019.86 189.702 1034.82C195.551 1049.79 212.409 1057.18 227.356 1051.34Z",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.117 999.555C193.496 1004.88 186.775 1020.25 192.104 1033.88C197.434 1047.52 212.796 1054.26 226.417 1048.94C240.037 1043.61 246.759 1028.24 241.429 1014.61C236.1 1000.97 220.738 994.232 207.117 999.555ZM187.301 1035.76C180.933 1019.47 188.964 1001.11 205.237 994.746C221.511 988.386 239.865 996.437 246.233 1012.73C252.6 1029.02 244.57 1047.38 228.296 1053.74C212.022 1060.1 193.668 1052.05 187.301 1035.76Z",
    fill: "#9C9C9C"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M169.3 1141.62C184.248 1135.78 191.624 1118.91 185.775 1103.95C179.927 1088.98 163.068 1081.59 148.121 1087.43C133.174 1093.27 125.798 1110.14 131.646 1125.1C137.495 1140.06 154.353 1147.46 169.3 1141.62Z",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.061 1089.83C135.44 1095.16 128.719 1110.53 134.048 1124.16C139.378 1137.8 154.74 1144.54 168.361 1139.21C181.981 1133.89 188.703 1118.52 183.373 1104.88C178.044 1091.25 162.682 1084.51 149.061 1089.83ZM129.245 1126.04C122.877 1109.75 130.908 1091.38 147.181 1085.02C163.455 1078.66 181.809 1086.71 188.177 1103.01C194.544 1119.3 186.514 1137.66 170.24 1144.02C153.967 1150.38 135.612 1142.33 129.245 1126.04Z",
    fill: "#9C9C9C"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M109.374 1215.99C124.321 1210.14 131.697 1193.28 125.848 1178.31C120 1163.35 103.142 1155.95 88.1945 1161.8C73.2473 1167.64 65.8713 1184.5 71.7198 1199.47C77.5683 1214.43 94.4265 1221.83 109.374 1215.99Z",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.1342 1164.2C75.5134 1169.52 68.792 1184.89 74.1215 1198.53C79.451 1212.17 94.8132 1218.9 108.434 1213.58C122.055 1208.26 128.776 1192.89 123.447 1179.25C118.117 1165.62 102.755 1158.88 89.1342 1164.2ZM69.3181 1200.41C62.9506 1184.12 70.9811 1165.75 87.2547 1159.39C103.528 1153.03 121.883 1161.08 128.25 1177.37C134.618 1193.67 126.587 1212.03 110.313 1218.39C94.0398 1224.75 75.6856 1216.7 69.3181 1200.41Z",
    fill: "#9C9C9C"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4771 1474.32C97.4243 1468.48 104.8 1451.61 98.9518 1436.64C93.1033 1421.68 76.245 1414.29 61.2978 1420.13C46.3506 1425.97 38.9746 1442.84 44.8231 1457.8C50.6716 1472.76 67.5299 1480.16 82.4771 1474.32Z",
    fill: "white"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.2376 1422.53C48.6168 1427.86 41.8954 1443.23 47.2249 1456.86C52.5544 1470.5 67.9166 1477.24 81.5374 1471.91C95.1582 1466.59 101.88 1451.22 96.5501 1437.58C91.2206 1423.95 75.8584 1417.21 62.2376 1422.53ZM42.4214 1458.74C36.0539 1442.45 44.0844 1424.08 60.3581 1417.72C76.6317 1411.36 94.986 1419.41 101.354 1435.71C107.721 1452 99.6905 1470.36 83.4168 1476.72C67.1432 1483.08 48.7889 1475.03 42.4214 1458.74Z",
    fill: "#9C9C9C"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M114.574 1564.94C129.521 1559.1 136.897 1542.24 131.048 1527.27C125.2 1512.31 108.342 1504.91 93.3945 1510.76C78.4472 1516.6 71.0713 1533.46 76.9198 1548.43C82.7683 1563.39 99.6265 1570.79 114.574 1564.94Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.3342 1513.16C80.7135 1518.48 73.992 1533.85 79.3215 1547.49C84.651 1561.13 100.013 1567.86 113.634 1562.54C127.255 1557.22 133.976 1541.85 128.647 1528.21C123.317 1514.58 107.955 1507.84 94.3342 1513.16ZM74.518 1549.37C68.1505 1533.08 76.1811 1514.71 92.4547 1508.35C108.728 1501.99 127.083 1510.04 133.45 1526.33C139.818 1542.63 131.787 1560.99 115.514 1567.35C99.2398 1573.71 80.8855 1565.66 74.518 1549.37Z",
    fill: "#9C9C9C"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M150.258 1654.94C165.206 1649.1 172.582 1632.23 166.733 1617.27C160.885 1602.3 144.026 1594.91 129.079 1600.75C114.132 1606.59 106.756 1623.46 112.604 1638.42C118.453 1653.39 135.311 1660.78 150.258 1654.94Z",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.019 1603.15C116.398 1608.48 109.677 1623.85 115.006 1637.48C120.336 1651.12 135.698 1657.86 149.319 1652.53C162.939 1647.21 169.661 1631.84 164.331 1618.21C159.002 1604.57 143.64 1597.83 130.019 1603.15ZM110.203 1639.36C103.835 1623.07 111.866 1604.71 128.139 1598.35C144.413 1591.98 162.767 1600.04 169.135 1616.33C175.502 1632.62 167.472 1650.98 151.198 1657.34C134.925 1663.7 116.57 1655.65 110.203 1639.36Z",
    fill: "#9C9C9C"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M186.84 1760.97C201.787 1755.12 209.163 1738.26 203.314 1723.29C197.466 1708.33 180.608 1700.94 165.66 1706.78C150.713 1712.62 143.337 1729.49 149.186 1744.45C155.034 1759.41 171.892 1766.81 186.84 1760.97Z",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.6 1709.18C152.979 1714.51 146.258 1729.88 151.587 1743.51C156.917 1757.15 172.279 1763.89 185.9 1758.56C199.521 1753.24 206.242 1737.87 200.913 1724.23C195.583 1710.6 180.221 1703.86 166.6 1709.18ZM146.784 1745.39C140.416 1729.1 148.447 1710.73 164.721 1704.37C180.994 1698.01 199.349 1706.06 205.716 1722.36C212.084 1738.65 204.053 1757.01 187.779 1763.37C171.506 1769.73 153.151 1761.68 146.784 1745.39Z",
    fill: "#9C9C9C"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M222.611 1851.18C237.558 1845.34 244.934 1828.47 239.086 1813.51C233.237 1798.55 216.379 1791.15 201.432 1796.99C186.485 1802.84 179.109 1819.7 184.957 1834.67C190.806 1849.63 207.664 1857.02 222.611 1851.18Z",
    fill: "white"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.372 1799.4C188.751 1804.72 182.029 1820.09 187.359 1833.73C192.688 1847.36 208.051 1854.1 221.671 1848.78C235.292 1843.45 242.014 1828.08 236.684 1814.45C231.355 1800.81 215.992 1794.07 202.372 1799.4ZM182.555 1835.6C176.188 1819.31 184.218 1800.95 200.492 1794.59C216.766 1788.23 235.12 1796.28 241.488 1812.57C247.855 1828.86 239.825 1847.23 223.551 1853.59C207.277 1859.95 188.923 1851.9 182.555 1835.6Z",
    fill: "#9C9C9C"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M259.386 1943.31C274.333 1937.47 281.709 1920.6 275.86 1905.64C270.012 1890.67 253.153 1883.28 238.206 1889.12C223.259 1894.96 215.883 1911.83 221.732 1926.79C227.58 1941.76 244.438 1949.15 259.386 1943.31Z",
    fill: "white"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.146 1891.53C225.525 1896.85 218.804 1912.22 224.133 1925.86C229.463 1939.49 244.825 1946.23 258.446 1940.91C272.067 1935.58 278.788 1920.21 273.459 1906.58C268.129 1892.94 252.767 1886.2 239.146 1891.53ZM219.33 1927.73C212.962 1911.44 220.993 1893.08 237.267 1886.72C253.54 1880.36 271.895 1888.41 278.262 1904.7C284.63 1920.99 276.599 1939.35 260.325 1945.71C244.052 1952.08 225.697 1944.02 219.33 1927.73Z",
    fill: "#9C9C9C"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M295.379 2033.44C310.326 2027.6 317.702 2010.73 311.854 1995.77C306.005 1980.8 289.147 1973.41 274.2 1979.25C259.252 1985.09 251.876 2001.96 257.725 2016.92C263.573 2031.89 280.432 2039.28 295.379 2033.44Z",
    fill: "white"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M275.139 1981.65C261.519 1986.98 254.797 2002.35 260.127 2015.98C265.456 2029.62 280.818 2036.36 294.439 2031.04C308.06 2025.71 314.781 2010.34 309.452 1996.71C304.122 1983.07 288.76 1976.33 275.139 1981.65ZM255.323 2017.86C248.956 2001.57 256.986 1983.21 273.26 1976.85C289.533 1970.49 307.888 1978.54 314.255 1994.83C320.623 2011.12 312.592 2029.48 296.319 2035.84C280.045 2042.2 261.691 2034.15 255.323 2017.86Z",
    fill: "#9C9C9C"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M336.658 2120.73C351.605 2114.89 358.981 2098.03 353.132 2083.06C347.284 2068.1 330.426 2060.7 315.478 2066.55C300.531 2072.39 293.155 2089.25 299.004 2104.22C304.852 2119.18 321.71 2126.58 336.658 2120.73Z",
    fill: "white"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M316.418 2068.95C302.797 2074.27 296.076 2089.64 301.405 2103.28C306.735 2116.92 322.097 2123.65 335.718 2118.33C349.339 2113.01 356.06 2097.64 350.731 2084C345.401 2070.36 330.039 2063.63 316.418 2068.95ZM296.602 2105.16C290.234 2088.86 298.265 2070.5 314.539 2064.14C330.812 2057.78 349.167 2065.83 355.534 2082.12C361.902 2098.42 353.871 2116.78 337.597 2123.14C321.324 2129.5 302.969 2121.45 296.602 2105.16Z",
    fill: "#9C9C9C"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M372.429 2210.95C387.376 2205.11 394.752 2188.24 388.904 2173.28C383.055 2158.31 366.197 2150.92 351.25 2156.76C336.303 2162.6 328.927 2179.47 334.775 2194.43C340.624 2209.4 357.482 2216.79 372.429 2210.95Z",
    fill: "white"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M352.19 2159.17C338.569 2164.49 331.847 2179.86 337.177 2193.5C342.506 2207.13 357.869 2213.87 371.489 2208.55C385.11 2203.22 391.832 2187.85 386.502 2174.22C381.173 2160.58 365.81 2153.84 352.19 2159.17ZM332.373 2195.37C326.006 2179.08 334.036 2160.72 350.31 2154.36C366.584 2148 384.938 2156.05 391.306 2172.34C397.673 2188.63 389.643 2206.99 373.369 2213.35C357.095 2219.72 338.741 2211.66 332.373 2195.37Z",
    fill: "#9C9C9C"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M1424.41 1925.49C1437.16 1920.51 1443.44 1906.14 1438.46 1893.38C1433.47 1880.62 1419.1 1874.32 1406.36 1879.3C1393.62 1884.28 1387.33 1898.66 1392.32 1911.41C1397.3 1924.17 1411.67 1930.47 1424.41 1925.49Z",
    fill: "white"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1407.16 1881.34C1395.55 1885.88 1389.82 1898.99 1394.36 1910.62C1398.9 1922.24 1412 1927.99 1423.62 1923.45C1435.23 1918.91 1440.96 1905.8 1436.42 1894.18C1431.87 1882.55 1418.77 1876.81 1407.16 1881.34ZM1390.27 1912.21C1384.85 1898.33 1391.69 1882.68 1405.56 1877.25C1419.43 1871.83 1435.07 1878.7 1440.5 1892.58C1445.93 1906.47 1439.08 1922.12 1425.21 1927.54C1411.34 1932.96 1395.7 1926.1 1390.27 1912.21Z",
    fill: "#9C9C9C"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M1527.35 1885.26C1540.09 1880.28 1546.38 1865.9 1541.39 1853.15C1536.41 1840.39 1522.04 1834.09 1509.29 1839.07C1496.55 1844.05 1490.26 1858.43 1495.25 1871.18C1500.24 1883.94 1514.61 1890.24 1527.35 1885.26Z",
    fill: "white"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1510.09 1841.11C1498.48 1845.65 1492.75 1858.76 1497.29 1870.38C1501.84 1882.01 1514.94 1887.76 1526.55 1883.22C1538.16 1878.68 1543.89 1865.57 1539.35 1853.95C1534.81 1842.32 1521.71 1836.57 1510.09 1841.11ZM1493.21 1871.98C1487.78 1858.1 1494.62 1842.44 1508.49 1837.02C1522.36 1831.6 1538.01 1838.46 1543.44 1852.35C1548.86 1866.24 1542.02 1881.89 1528.15 1887.31C1514.28 1892.73 1498.63 1885.87 1493.21 1871.98Z",
    fill: "#9C9C9C"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M1214.11 2007.69C1226.85 2002.71 1233.14 1988.33 1228.16 1975.57C1223.17 1962.82 1208.8 1956.51 1196.06 1961.49C1183.32 1966.47 1177.03 1980.85 1182.01 1993.61C1187 2006.36 1201.37 2012.67 1214.11 2007.69Z",
    fill: "white"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1196.86 1963.54C1185.24 1968.08 1179.51 1981.18 1184.06 1992.81C1188.6 2004.44 1201.7 2010.18 1213.31 2005.64C1224.93 2001.1 1230.66 1988 1226.11 1976.37C1221.57 1964.75 1208.47 1959 1196.86 1963.54ZM1179.97 1994.41C1174.54 1980.52 1181.39 1964.87 1195.26 1959.45C1209.13 1954.03 1224.77 1960.89 1230.2 1974.78C1235.63 1988.66 1228.78 2004.31 1214.91 2009.73C1201.04 2015.15 1185.4 2008.29 1179.97 1994.41Z",
    fill: "#9C9C9C"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M1317.04 1967.46C1329.79 1962.48 1336.07 1948.1 1331.09 1935.34C1326.1 1922.59 1311.73 1916.28 1298.99 1921.26C1286.25 1926.24 1279.96 1940.62 1284.95 1953.38C1289.93 1966.13 1304.3 1972.44 1317.04 1967.46Z",
    fill: "white"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1299.79 1923.31C1288.18 1927.85 1282.45 1940.95 1286.99 1952.58C1291.53 1964.21 1304.63 1969.95 1316.25 1965.41C1327.86 1960.87 1333.59 1947.77 1329.05 1936.14C1324.5 1924.52 1311.4 1918.77 1299.79 1923.31ZM1282.9 1954.18C1277.48 1940.29 1284.32 1924.64 1298.19 1919.22C1312.06 1913.8 1327.7 1920.66 1333.13 1934.55C1338.56 1948.43 1331.71 1964.08 1317.84 1969.5C1303.97 1974.92 1288.33 1968.06 1282.9 1954.18Z",
    fill: "#9C9C9C"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M1842.58 1762.06C1855.32 1757.08 1861.61 1742.7 1856.62 1729.94C1851.64 1717.19 1837.27 1710.88 1824.53 1715.86C1811.78 1720.84 1805.5 1735.22 1810.48 1747.98C1815.47 1760.73 1829.84 1767.04 1842.58 1762.06Z",
    fill: "white"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1825.33 1717.91C1813.71 1722.45 1807.98 1735.55 1812.53 1747.18C1817.07 1758.81 1830.17 1764.55 1841.78 1760.01C1853.4 1755.47 1859.13 1742.37 1854.58 1730.74C1850.04 1719.11 1836.94 1713.37 1825.33 1717.91ZM1808.44 1748.78C1803.01 1734.89 1809.86 1719.24 1823.73 1713.82C1837.6 1708.4 1853.24 1715.26 1858.67 1729.14C1864.1 1743.03 1857.25 1758.68 1843.38 1764.1C1829.51 1769.52 1813.87 1762.66 1808.44 1748.78Z",
    fill: "#9C9C9C"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M1945.51 1721.83C1958.26 1716.85 1964.54 1702.47 1959.56 1689.71C1954.57 1676.96 1940.2 1670.65 1927.46 1675.63C1914.72 1680.61 1908.43 1694.99 1913.42 1707.75C1918.4 1720.5 1932.77 1726.81 1945.51 1721.83Z",
    fill: "white"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1928.26 1677.68C1916.65 1682.22 1910.91 1695.32 1915.46 1706.95C1920 1718.58 1933.1 1724.32 1944.72 1719.78C1956.33 1715.24 1962.06 1702.14 1957.52 1690.51C1952.97 1678.88 1939.87 1673.14 1928.26 1677.68ZM1911.37 1708.55C1905.95 1694.66 1912.79 1679.01 1926.66 1673.59C1940.53 1668.17 1956.17 1675.03 1961.6 1688.91C1967.03 1702.8 1960.18 1718.45 1946.31 1723.87C1932.44 1729.29 1916.8 1722.43 1911.37 1708.55Z",
    fill: "#9C9C9C"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M1632.28 1844.25C1645.02 1839.27 1651.31 1824.89 1646.32 1812.14C1641.34 1799.38 1626.97 1793.08 1614.22 1798.06C1601.48 1803.04 1595.19 1817.42 1600.18 1830.17C1605.17 1842.93 1619.54 1849.23 1632.28 1844.25Z",
    fill: "white"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1615.02 1800.1C1603.41 1804.64 1597.68 1817.75 1602.22 1829.37C1606.77 1841 1619.86 1846.75 1631.48 1842.21C1643.09 1837.67 1648.82 1824.56 1644.28 1812.94C1639.73 1801.31 1626.64 1795.56 1615.02 1800.1ZM1598.14 1830.97C1592.71 1817.09 1599.55 1801.43 1613.42 1796.01C1627.29 1790.59 1642.94 1797.45 1648.36 1811.34C1653.79 1825.23 1646.95 1840.88 1633.08 1846.3C1619.21 1851.72 1603.56 1844.86 1598.14 1830.97Z",
    fill: "#9C9C9C"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M1735.21 1804.02C1747.95 1799.04 1754.24 1784.66 1749.26 1771.91C1744.27 1759.15 1729.9 1752.85 1717.16 1757.83C1704.41 1762.81 1698.13 1777.19 1703.11 1789.94C1708.1 1802.7 1722.47 1809 1735.21 1804.02Z",
    fill: "white"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1717.96 1759.87C1706.34 1764.41 1700.61 1777.52 1705.16 1789.14C1709.7 1800.77 1722.8 1806.52 1734.41 1801.98C1746.03 1797.44 1751.76 1784.33 1747.21 1772.71C1742.67 1761.08 1729.57 1755.33 1717.96 1759.87ZM1701.07 1790.74C1695.64 1776.85 1702.49 1761.2 1716.36 1755.78C1730.23 1750.36 1745.87 1757.22 1751.3 1771.11C1756.73 1784.99 1749.88 1800.65 1736.01 1806.07C1722.14 1811.49 1706.5 1804.63 1701.07 1790.74Z",
    fill: "#9C9C9C"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M2271.4 1594.46C2284.14 1589.48 2290.43 1575.1 2285.44 1562.34C2280.45 1549.59 2266.08 1543.28 2253.34 1548.27C2240.6 1553.25 2234.31 1567.62 2239.3 1580.38C2244.28 1593.14 2258.65 1599.44 2271.4 1594.46Z",
    fill: "white"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2254.14 1550.31C2242.53 1554.85 2236.8 1567.95 2241.34 1579.58C2245.88 1591.21 2258.98 1596.95 2270.6 1592.41C2282.21 1587.87 2287.94 1574.77 2283.4 1563.14C2278.85 1551.52 2265.75 1545.77 2254.14 1550.31ZM2237.25 1581.18C2231.83 1567.29 2238.67 1551.64 2252.54 1546.22C2266.41 1540.8 2282.06 1547.66 2287.48 1561.55C2292.91 1575.43 2286.07 1591.08 2272.2 1596.5C2258.32 1601.93 2242.68 1595.06 2237.25 1581.18Z",
    fill: "#9C9C9C"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M2374.33 1554.23C2387.07 1549.25 2393.36 1534.87 2388.37 1522.11C2383.39 1509.36 2369.02 1503.05 2356.27 1508.03C2343.53 1513.01 2337.24 1527.39 2342.23 1540.15C2347.22 1552.9 2361.59 1559.21 2374.33 1554.23Z",
    fill: "white"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2357.07 1510.08C2345.46 1514.62 2339.73 1527.72 2344.27 1539.35C2348.82 1550.98 2361.92 1556.72 2373.53 1552.18C2385.14 1547.64 2390.87 1534.54 2386.33 1522.91C2381.79 1511.29 2368.69 1505.54 2357.07 1510.08ZM2340.19 1540.95C2334.76 1527.06 2341.61 1511.41 2355.48 1505.99C2369.35 1500.57 2384.99 1507.43 2390.42 1521.32C2395.84 1535.2 2389 1550.85 2375.13 1556.27C2361.26 1561.69 2345.61 1554.83 2340.19 1540.95Z",
    fill: "#9C9C9C"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M2060.87 1676.74C2073.61 1671.76 2079.9 1657.38 2074.91 1644.63C2069.93 1631.87 2055.56 1625.57 2042.82 1630.55C2030.07 1635.53 2023.79 1649.9 2028.77 1662.66C2033.76 1675.42 2048.13 1681.72 2060.87 1676.74Z",
    fill: "white"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2043.62 1632.59C2032 1637.13 2026.27 1650.24 2030.81 1661.86C2035.36 1673.49 2048.46 1679.23 2060.07 1674.7C2071.69 1670.16 2077.42 1657.05 2072.87 1645.43C2068.33 1633.8 2055.23 1628.05 2043.62 1632.59ZM2026.73 1663.46C2021.3 1649.57 2028.15 1633.92 2042.02 1628.5C2055.89 1623.08 2071.53 1629.94 2076.96 1643.83C2082.38 1657.71 2075.54 1673.36 2061.67 1678.79C2047.8 1684.21 2032.16 1677.35 2026.73 1663.46Z",
    fill: "#9C9C9C"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M2164.03 1636.42C2176.77 1631.44 2183.06 1617.07 2178.07 1604.31C2173.08 1591.55 2158.71 1585.25 2145.97 1590.23C2133.23 1595.21 2126.94 1609.59 2131.93 1622.34C2136.91 1635.1 2151.28 1641.4 2164.03 1636.42Z",
    fill: "white"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2146.77 1592.27C2135.16 1596.81 2129.43 1609.92 2133.97 1621.55C2138.51 1633.17 2151.61 1638.92 2163.23 1634.38C2174.84 1629.84 2180.57 1616.73 2176.03 1605.11C2171.48 1593.48 2158.38 1587.74 2146.77 1592.27ZM2129.88 1623.14C2124.46 1609.26 2131.3 1593.61 2145.17 1588.18C2159.04 1582.76 2174.69 1589.63 2180.11 1603.51C2185.54 1617.4 2178.7 1633.05 2164.83 1638.47C2150.96 1643.89 2135.31 1637.03 2129.88 1623.14Z",
    fill: "#9C9C9C"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M2689.56 1431.02C2702.3 1426.04 2708.59 1411.66 2703.61 1398.91C2698.62 1386.15 2684.25 1379.85 2671.51 1384.83C2658.77 1389.81 2652.48 1404.19 2657.46 1416.94C2662.45 1429.7 2676.82 1436 2689.56 1431.02Z",
    fill: "white"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2672.31 1386.87C2660.69 1391.41 2654.96 1404.52 2659.51 1416.14C2664.05 1427.77 2677.15 1433.52 2688.76 1428.98C2700.38 1424.44 2706.11 1411.33 2701.56 1399.71C2697.02 1388.08 2683.92 1382.33 2672.31 1386.87ZM2655.42 1417.74C2649.99 1403.86 2656.84 1388.2 2670.71 1382.78C2684.58 1377.36 2700.22 1384.22 2705.65 1398.11C2711.08 1412 2704.23 1427.65 2690.36 1433.07C2676.49 1438.49 2660.85 1431.63 2655.42 1417.74Z",
    fill: "#9C9C9C"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M2792.5 1390.79C2805.24 1385.81 2811.52 1371.43 2806.54 1358.68C2801.55 1345.92 2787.18 1339.62 2774.44 1344.6C2761.7 1349.58 2755.41 1363.96 2760.4 1376.71C2765.38 1389.47 2779.75 1395.77 2792.5 1390.79Z",
    fill: "white"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2775.24 1346.64C2763.63 1351.18 2757.9 1364.29 2762.44 1375.91C2766.98 1387.54 2780.08 1393.29 2791.7 1388.75C2803.31 1384.21 2809.04 1371.1 2804.5 1359.48C2799.95 1347.85 2786.85 1342.1 2775.24 1346.64ZM2758.35 1377.51C2752.93 1363.63 2759.77 1347.97 2773.64 1342.55C2787.51 1337.13 2803.15 1343.99 2808.58 1357.88C2814.01 1371.77 2807.16 1387.42 2793.29 1392.84C2779.42 1398.26 2763.78 1391.4 2758.35 1377.51Z",
    fill: "#9C9C9C"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M2871.92 1358.47C2884.66 1353.49 2890.95 1339.11 2885.97 1326.35C2880.98 1313.6 2866.61 1307.29 2853.87 1312.27C2841.13 1317.25 2834.84 1331.63 2839.82 1344.39C2844.81 1357.15 2859.18 1363.45 2871.92 1358.47Z",
    fill: "white"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2854.67 1314.32C2843.05 1318.86 2837.32 1331.96 2841.87 1343.59C2846.41 1355.22 2859.51 1360.96 2871.12 1356.42C2882.74 1351.88 2888.47 1338.78 2883.92 1327.15C2879.38 1315.53 2866.28 1309.78 2854.67 1314.32ZM2837.78 1345.19C2832.35 1331.3 2839.2 1315.65 2853.07 1310.23C2866.94 1304.81 2882.58 1311.67 2888.01 1325.56C2893.44 1339.44 2886.59 1355.09 2872.72 1360.51C2858.85 1365.93 2843.21 1359.07 2837.78 1345.19Z",
    fill: "#9C9C9C"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M2479.26 1513.22C2492 1508.24 2498.29 1493.86 2493.3 1481.1C2488.32 1468.35 2473.95 1462.04 2461.2 1467.02C2448.46 1472 2442.17 1486.38 2447.16 1499.14C2452.15 1511.89 2466.52 1518.2 2479.26 1513.22Z",
    fill: "white"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2462 1469.07C2450.39 1473.61 2444.66 1486.71 2449.2 1498.34C2453.75 1509.97 2466.85 1515.71 2478.46 1511.17C2490.07 1506.63 2495.8 1493.53 2491.26 1481.9C2486.72 1470.28 2473.62 1464.53 2462 1469.07ZM2445.12 1499.94C2439.69 1486.05 2446.53 1470.4 2460.4 1464.98C2474.27 1459.56 2489.92 1466.42 2495.35 1480.31C2500.77 1494.19 2493.93 1509.84 2480.06 1515.26C2466.19 1520.68 2450.54 1513.82 2445.12 1499.94Z",
    fill: "#9C9C9C"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M2582.19 1472.99C2594.93 1468.01 2601.22 1453.63 2596.24 1440.87C2591.25 1428.12 2576.88 1421.81 2564.14 1426.79C2551.4 1431.77 2545.11 1446.15 2550.09 1458.91C2555.08 1471.66 2569.45 1477.97 2582.19 1472.99Z",
    fill: "white"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2564.94 1428.84C2553.32 1433.38 2547.59 1446.48 2552.14 1458.11C2556.68 1469.74 2569.78 1475.48 2581.39 1470.94C2593.01 1466.4 2598.74 1453.3 2594.19 1441.67C2589.65 1430.04 2576.55 1424.3 2564.94 1428.84ZM2548.05 1459.71C2542.62 1445.82 2549.47 1430.17 2563.34 1424.75C2577.21 1419.33 2592.85 1426.19 2598.28 1440.07C2603.71 1453.96 2596.86 1469.61 2582.99 1475.03C2569.12 1480.45 2553.48 1473.59 2548.05 1459.71Z",
    fill: "#9C9C9C"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M1391.11 445.964C1406.42 439.978 1413.98 422.697 1407.99 407.365C1401.99 392.033 1384.72 384.457 1369.41 390.442C1354.09 396.428 1346.54 413.709 1352.53 429.041C1358.52 444.373 1375.79 451.95 1391.11 445.964Z",
    fill: "white"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1370.37 392.902C1356.41 398.357 1349.52 414.107 1354.98 428.081C1360.45 442.054 1376.19 448.959 1390.15 443.504C1404.1 438.049 1410.99 422.299 1405.53 408.325C1400.07 394.352 1384.33 387.447 1370.37 392.902ZM1350.07 430.001C1343.55 413.311 1351.77 394.499 1368.45 387.983C1385.12 381.467 1403.92 389.715 1410.44 406.405C1416.97 423.095 1408.74 441.908 1392.07 448.424C1375.4 454.94 1356.59 446.692 1350.07 430.001Z",
    fill: "#9C9C9C"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M1486.05 408.855C1501.37 402.869 1508.93 385.588 1502.93 370.256C1496.94 354.924 1479.67 347.348 1464.35 353.333C1449.04 359.319 1441.48 376.6 1447.47 391.932C1453.47 407.264 1470.74 414.84 1486.05 408.855Z",
    fill: "white"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1465.32 355.793C1451.36 361.248 1444.47 376.998 1449.93 390.972C1455.39 404.945 1471.14 411.85 1485.09 406.395C1499.05 400.94 1505.94 385.19 1500.48 371.216C1495.02 357.243 1479.27 350.338 1465.32 355.793ZM1445.02 392.892C1438.49 376.202 1446.72 357.389 1463.39 350.873C1480.06 344.357 1498.87 352.605 1505.39 369.296C1511.91 385.986 1503.69 404.798 1487.02 411.314C1470.34 417.83 1451.54 409.583 1445.02 392.892Z",
    fill: "#9C9C9C"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M1585.22 370.098C1600.53 364.113 1608.09 346.831 1602.1 331.499C1596.1 316.168 1578.83 308.591 1563.52 314.577C1548.2 320.562 1540.64 337.843 1546.64 353.175C1552.63 368.507 1569.9 376.084 1585.22 370.098Z",
    fill: "white"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1564.48 317.036C1550.52 322.492 1543.63 338.242 1549.09 352.215C1554.55 366.189 1570.3 373.094 1584.26 367.639C1598.21 362.183 1605.1 346.433 1599.64 332.46C1594.18 318.486 1578.44 311.581 1564.48 317.036ZM1544.18 354.136C1537.66 337.445 1545.88 318.633 1562.55 312.117C1579.23 305.601 1598.03 313.849 1604.55 330.539C1611.08 347.23 1602.85 366.042 1586.18 372.558C1569.51 379.074 1550.7 370.826 1544.18 354.136Z",
    fill: "#9C9C9C"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M1671.51 336.371C1686.83 330.385 1694.38 313.104 1688.39 297.772C1682.4 282.44 1665.13 274.863 1649.81 280.849C1634.5 286.835 1626.94 304.116 1632.93 319.448C1638.92 334.78 1656.2 342.356 1671.51 336.371Z",
    fill: "white"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1650.77 283.309C1636.82 288.764 1629.93 304.514 1635.39 318.487C1640.85 332.461 1656.59 339.366 1670.55 333.911C1684.51 328.455 1691.4 312.705 1685.93 298.732C1680.47 284.759 1664.73 277.853 1650.77 283.309ZM1630.47 320.408C1623.95 303.718 1632.18 284.905 1648.85 278.389C1665.52 271.873 1684.33 280.121 1690.85 296.812C1697.37 313.502 1689.14 332.314 1672.47 338.83C1655.8 345.346 1637 337.098 1630.47 320.408Z",
    fill: "#9C9C9C"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M1770.67 297.614C1785.99 291.628 1793.55 274.347 1787.55 259.015C1781.56 243.683 1764.29 236.107 1748.97 242.092C1733.66 248.078 1726.1 265.359 1732.09 280.691C1738.09 296.023 1755.36 303.6 1770.67 297.614Z",
    fill: "white"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1749.93 244.552C1735.98 250.007 1729.09 265.757 1734.55 279.731C1740.01 293.704 1755.75 300.61 1769.71 295.154C1783.67 289.699 1790.56 273.949 1785.1 259.976C1779.64 246.002 1763.89 239.097 1749.93 244.552ZM1729.64 281.651C1723.11 264.961 1731.34 246.149 1748.01 239.633C1764.68 233.117 1783.49 241.365 1790.01 258.055C1796.53 274.745 1788.31 293.558 1771.64 300.074C1754.96 306.59 1736.16 298.342 1729.64 281.651Z",
    fill: "#9C9C9C"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M1865.4 260.592C1880.71 254.606 1888.27 237.325 1882.28 221.993C1876.29 206.661 1859.01 199.084 1843.7 205.07C1828.38 211.056 1820.83 228.337 1826.82 243.669C1832.81 259.001 1850.08 266.577 1865.4 260.592Z",
    fill: "white"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1844.66 207.53C1830.7 212.985 1823.81 228.735 1829.28 242.708C1834.74 256.682 1850.48 263.587 1864.44 258.132C1878.4 252.677 1885.28 236.926 1879.82 222.953C1874.36 208.98 1858.62 202.074 1844.66 207.53ZM1824.36 244.629C1817.84 227.939 1826.07 209.126 1842.74 202.61C1859.41 196.094 1878.21 204.342 1884.74 221.032C1891.26 237.723 1883.03 256.535 1866.36 263.051C1849.69 269.567 1830.89 261.319 1824.36 244.629Z",
    fill: "#9C9C9C"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M1964.78 221.748C1980.1 215.763 1987.65 198.481 1981.66 183.15C1975.67 167.818 1958.4 160.241 1943.08 166.227C1927.77 172.212 1920.21 189.494 1926.2 204.825C1932.2 220.157 1949.47 227.734 1964.78 221.748Z",
    fill: "white"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1944.04 168.686C1930.09 174.142 1923.2 189.892 1928.66 203.865C1934.12 217.839 1949.86 224.744 1963.82 219.289C1977.78 213.833 1984.67 198.083 1979.21 184.11C1973.74 170.136 1958 163.231 1944.04 168.686ZM1923.75 205.786C1917.22 189.095 1925.45 170.283 1942.12 163.767C1958.79 157.251 1977.6 165.499 1984.12 182.189C1990.64 198.88 1982.42 217.692 1965.74 224.208C1949.07 230.724 1930.27 222.476 1923.75 205.786Z",
    fill: "#9C9C9C"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M2045.31 190.275C2060.62 184.289 2068.18 167.008 2062.19 151.676C2056.2 136.344 2038.92 128.768 2023.61 134.753C2008.3 140.739 2000.74 158.02 2006.73 173.352C2012.72 188.684 2030 196.261 2045.31 190.275Z",
    fill: "white"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2024.57 137.213C2010.61 142.668 2003.73 158.418 2009.19 172.392C2014.65 186.365 2030.39 193.271 2044.35 187.815C2058.31 182.36 2065.19 166.61 2059.73 152.636C2054.27 138.663 2038.53 131.758 2024.57 137.213ZM2004.27 174.312C1997.75 157.622 2005.98 138.81 2022.65 132.294C2039.32 125.778 2058.12 134.026 2064.65 150.716C2071.17 167.406 2062.94 186.219 2046.27 192.735C2029.6 199.251 2010.8 191.003 2004.27 174.312Z",
    fill: "#9C9C9C"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M2144.69 151.432C2160.01 145.446 2167.57 128.165 2161.57 112.833C2155.58 97.5011 2138.31 89.9245 2122.99 95.9101C2107.68 101.896 2100.12 119.177 2106.11 134.509C2112.11 149.841 2129.38 157.417 2144.69 151.432Z",
    fill: "white"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2123.96 98.3699C2110 103.825 2103.11 119.575 2108.57 133.549C2114.03 147.522 2129.77 154.427 2143.73 148.972C2157.69 143.517 2164.58 127.767 2159.12 113.793C2153.66 99.8198 2137.91 92.9146 2123.96 98.3699ZM2103.66 135.469C2097.13 118.779 2105.36 99.9664 2122.03 93.4504C2138.7 86.9344 2157.51 95.1823 2164.03 111.873C2170.55 128.563 2162.33 147.375 2145.66 153.891C2128.98 160.407 2110.18 152.16 2103.66 135.469Z",
    fill: "#9C9C9C"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M2221.14 121.297C2236.46 115.311 2244.01 98.0301 2238.02 82.6982C2232.03 67.3663 2214.76 59.7897 2199.44 65.7753C2184.13 71.7609 2176.57 89.0422 2182.56 104.374C2188.55 119.706 2205.83 127.283 2221.14 121.297Z",
    fill: "white"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2200.4 68.235C2186.44 73.6903 2179.56 89.4404 2185.02 103.414C2190.48 117.387 2206.22 124.293 2220.18 118.837C2234.14 113.382 2241.03 97.6319 2235.56 83.6585C2230.1 69.6851 2214.36 62.7797 2200.4 68.235ZM2180.1 105.334C2173.58 88.644 2181.81 69.8316 2198.48 63.3156C2215.15 56.7996 2233.96 65.0476 2240.48 81.7379C2247 98.4282 2238.77 117.241 2222.1 123.757C2205.43 130.273 2186.63 122.025 2180.1 105.334Z",
    fill: "#9C9C9C"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1289.81 427.529L1332.91 548.929L1327.94 550.694L1284.84 429.293L1289.81 427.529Z",
    fill: "#9C9C9C"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1320.65 415.477L1363.75 536.877L1358.78 538.642L1315.68 417.242L1320.65 415.477Z",
    fill: "#9C9C9C"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1357.47 401.084L1400.57 522.485L1395.6 524.25L1352.5 402.849L1357.47 401.084Z",
    fill: "#9C9C9C"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1388.31 389.032L1431.41 510.433L1426.44 512.198L1383.34 390.797L1388.31 389.032Z",
    fill: "#9C9C9C"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M885.399 585.585L928.722 706.899L923.753 708.673L880.43 587.359L885.399 585.585Z",
    fill: "#9C9C9C"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M916.234 573.533L959.557 694.847L954.588 696.621L911.266 575.307L916.234 573.533Z",
    fill: "#9C9C9C"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M953.06 559.14L996.382 680.454L991.414 682.228L948.091 560.914L953.06 559.14Z",
    fill: "#9C9C9C"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M983.895 547.088L1027.22 668.402L1022.25 670.176L978.926 548.862L983.895 547.088Z",
    fill: "#9C9C9C"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1423.58 375.246L1466.68 496.647L1461.71 498.412L1418.61 377.011L1423.58 375.246Z",
    fill: "#9C9C9C"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1454.42 363.194L1497.52 484.595L1492.55 486.36L1449.45 364.959L1454.42 363.194Z",
    fill: "#9C9C9C"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1491.24 348.802L1534.34 470.202L1529.37 471.967L1486.27 350.566L1491.24 348.802Z",
    fill: "#9C9C9C"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1522.08 336.75L1565.18 458.151L1560.21 459.915L1517.11 338.515L1522.08 336.75Z",
    fill: "#9C9C9C"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1554.02 324.26L1597.34 445.574L1592.38 447.348L1549.05 326.034L1554.02 324.26Z",
    fill: "#9C9C9C"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1584.86 312.208L1628.18 433.522L1623.21 435.296L1579.89 313.982L1584.86 312.208Z",
    fill: "#9C9C9C"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1621.68 297.815L1665 419.129L1660.04 420.903L1616.71 299.589L1621.68 297.815Z",
    fill: "#9C9C9C"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1652.52 285.764L1695.84 407.077L1690.87 408.852L1647.55 287.538L1652.52 285.764Z",
    fill: "#9C9C9C"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1687.79 271.978L1731.11 393.292L1726.14 395.066L1682.82 273.752L1687.79 271.978Z",
    fill: "#9C9C9C"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1718.63 259.926L1761.95 381.24L1756.98 383.014L1713.66 261.7L1718.63 259.926Z",
    fill: "#9C9C9C"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1755.45 245.533L1798.77 366.847L1793.8 368.621L1750.48 247.307L1755.45 245.533Z",
    fill: "#9C9C9C"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1786.29 233.481L1829.61 354.795L1824.64 356.569L1781.32 235.255L1786.29 233.481Z",
    fill: "#9C9C9C"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1824.37 222.955L1867.38 344.134L1862.41 345.898L1819.39 224.72L1824.37 222.955Z",
    fill: "#9C9C9C"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1855.2 210.904L1898.22 332.082L1893.24 333.847L1850.23 212.668L1855.2 210.904Z",
    fill: "#9C9C9C"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1892.03 196.511L1935.04 317.689L1930.07 319.454L1887.06 198.275L1892.03 196.511Z",
    fill: "#9C9C9C"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1922.86 184.459L1965.88 305.638L1960.91 307.402L1917.89 186.223L1922.86 184.459Z",
    fill: "#9C9C9C"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1958.14 170.673L2001.15 291.852L1996.18 293.616L1953.16 172.438L1958.14 170.673Z",
    fill: "#9C9C9C"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1988.97 158.621L2031.99 279.8L2027.01 281.564L1984 160.386L1988.97 158.621Z",
    fill: "#9C9C9C"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2025.8 144.229L2068.81 265.407L2063.84 267.172L2020.82 145.993L2025.8 144.229Z",
    fill: "#9C9C9C"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2056.63 132.177L2099.65 253.355L2094.67 255.12L2051.66 133.941L2056.63 132.177Z",
    fill: "#9C9C9C"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2088.58 119.687L2131.81 240.779L2126.84 242.552L2083.61 121.46L2088.58 119.687Z",
    fill: "#9C9C9C"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2119.41 107.635L2162.65 228.727L2157.68 230.501L2114.44 109.409L2119.41 107.635Z",
    fill: "#9C9C9C"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2156.24 93.2421L2199.47 214.334L2194.5 216.108L2151.27 95.0159L2156.24 93.2421Z",
    fill: "#9C9C9C"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2187.07 81.1903L2230.31 202.282L2225.34 204.056L2182.1 82.964L2187.07 81.1903Z",
    fill: "#9C9C9C"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2222.34 67.4046L2265.58 188.496L2260.61 190.27L2217.38 69.1784L2222.34 67.4046Z",
    fill: "#9C9C9C"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2253.18 55.3527L2296.42 176.445L2291.45 178.218L2248.21 57.1265L2253.18 55.3527Z",
    fill: "#9C9C9C"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2290 40.96L2333.24 162.052L2328.27 163.826L2285.04 42.7337L2290 40.96Z",
    fill: "#9C9C9C"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2320.84 28.9081L2364.08 150L2359.11 151.774L2315.87 30.6819L2320.84 28.9081Z",
    fill: "#9C9C9C"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M508.612 721.5L1027.73 518.608C1038.73 514.31 1050.3 517.911 1058.38 521.84C1062.54 523.859 1066.05 526.104 1068.53 527.838C1069.77 528.708 1070.77 529.457 1071.46 529.997C1071.8 530.267 1072.07 530.486 1072.26 530.641C1072.36 530.719 1072.43 530.781 1072.49 530.826L1072.55 530.881L1072.57 530.898L1072.58 530.904L1072.58 530.907C1072.58 530.907 1072.58 530.909 1069.5 534.54C1073.59 532.092 1073.59 532.093 1073.59 532.093L1073.59 532.101L1073.61 532.124L1073.87 532.562C1073.97 532.739 1074.11 532.963 1074.26 533.232C1074.38 533.429 1074.51 533.65 1074.66 533.895C1075.34 535.049 1076.32 536.717 1077.53 538.775C1079.93 542.889 1083.21 548.567 1086.71 554.82C1093.66 567.22 1101.69 582.222 1105.39 591.684C1109.34 601.788 1109.32 612.055 1108.41 619.618C1107.95 623.428 1107.25 626.631 1106.66 628.897C1106.37 630.032 1106.1 630.937 1105.9 631.572C1105.83 631.802 1105.76 631.998 1105.71 632.155C1105.69 632.215 1105.67 632.269 1105.66 632.318C1105.62 632.407 1105.6 632.479 1105.58 632.531L1105.56 632.596L1105.55 632.617L1105.55 632.626L1105.55 632.629C1105.55 632.629 1105.55 632.632 1101.07 631.007L1105.55 632.632L1104.81 634.663L1059.87 652.23L1036.34 575.699L515.705 783.491L243.231 1039.95L238.798 1046.45C235.773 1050.89 231.426 1057.27 226.134 1065.03C215.549 1080.55 201.186 1101.61 186.069 1123.74C155.844 1168 122.581 1216.6 110.511 1233.88C98.2358 1251.46 84.6285 1265.92 71.971 1275.74C65.6455 1280.65 59.4541 1284.48 53.6932 1286.94C48.0006 1289.36 42.3265 1290.62 37.2201 1289.84C26.9677 1288.26 19.9808 1279.57 18.4403 1269.34C16.8765 1258.94 20.7361 1246.78 31.7418 1236.69C41.2816 1227.94 58.5894 1205.26 76.3157 1180.7C89.1696 1162.88 102.012 1144.41 111.922 1130.15C115.581 1124.89 118.841 1120.2 121.554 1116.33C131.543 1102.09 154.734 1067.96 175.455 1037.36C185.81 1022.06 195.539 1007.66 202.679 997.084C206.249 991.795 209.172 987.461 211.202 984.451L214.369 979.753C214.369 979.753 214.37 979.752 218.321 982.42C215.134 978.873 215.135 978.872 215.137 978.871L217.677 976.586C219.336 975.093 221.773 972.902 224.882 970.107C231.1 964.517 240.006 956.512 250.757 946.856C272.259 927.543 301.144 901.62 330.675 875.18C389.639 822.387 451.436 767.303 461.897 758.934C472.22 750.676 483.757 741.431 492.713 734.251C497.191 730.661 501.024 727.587 503.737 725.411L508.039 721.959L508.043 721.956C508.043 721.956 508.044 721.956 511.026 725.677L508.043 721.956L508.612 721.5ZM513.44 729.853L509.7 732.854C506.986 735.03 503.153 738.105 498.674 741.696C489.717 748.877 478.177 758.124 467.85 766.385C457.66 774.536 396.18 829.332 337.031 882.289C307.505 908.725 278.624 934.644 257.124 953.955C246.374 963.611 237.47 971.614 231.253 977.203C228.144 979.998 225.708 982.189 224.049 983.681L221.943 985.575L219.102 989.79C217.071 992.801 214.147 997.136 210.576 1002.43C203.434 1013.01 193.703 1027.41 183.345 1042.71C162.642 1073.29 139.399 1107.49 129.355 1121.81C126.675 1125.63 123.439 1130.29 119.797 1135.53C109.879 1149.8 96.9497 1168.4 84.0421 1186.28C66.5193 1210.57 48.5974 1234.17 38.1811 1243.72C29.2307 1251.93 26.8253 1261.03 27.8627 1267.92C28.9236 1274.97 33.4044 1279.6 38.6613 1280.41C41.3095 1280.82 45.0828 1280.24 49.9525 1278.16C54.754 1276.11 60.2399 1272.77 66.1289 1268.2C77.9005 1259.07 90.8709 1245.35 102.7 1228.41C114.734 1211.19 147.961 1162.63 178.201 1118.36C193.316 1096.22 207.679 1075.17 218.262 1059.65C223.554 1051.89 227.901 1045.51 230.925 1041.08L235.648 1034.14C235.648 1034.14 235.65 1034.14 239.587 1036.83L235.648 1034.14L235.943 1033.71L510.491 775.303L1042.41 563.008L1065.95 639.61L1097.19 627.401C1097.27 627.124 1097.35 626.821 1097.44 626.493C1097.94 624.556 1098.55 621.777 1098.95 618.466C1099.76 611.788 1099.68 603.26 1096.51 595.152C1093.09 586.404 1085.4 571.966 1078.4 559.48C1074.93 553.289 1071.68 547.662 1069.3 543.582C1068.11 541.543 1067.14 539.891 1066.46 538.751C1066.21 538.33 1066 537.98 1065.84 537.705C1065.77 537.645 1065.68 537.581 1065.59 537.511C1065.02 537.062 1064.16 536.414 1063.07 535.651C1060.89 534.12 1057.81 532.159 1054.22 530.417C1046.83 526.825 1038.39 524.681 1031.2 527.492L513.44 729.853ZM218.321 982.42L215.134 978.873L214.698 979.265L214.369 979.753L218.321 982.42ZM1069.5 534.54L1073.59 532.093L1073.18 531.418L1072.59 530.909L1069.5 534.54Z",
    fill: "#9C9C9C"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M847.441 589.881L893.233 712.278L888.292 714.126L842.5 591.729L847.441 589.881Z",
    fill: "#9C9C9C"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M865.055 667.711L849.083 673.954L847.162 669.04L863.135 662.797L865.055 667.711Z",
    fill: "#9C9C9C"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M854.099 682.307L870.219 675.874L878.604 696.884L862.484 703.317L854.099 682.307ZM860.87 685.22L865.389 696.544L871.834 693.971L867.314 682.647L860.87 685.22Z",
    fill: "#9C9C9C"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M859.663 680.043L854.889 667.828L859.74 665.932L864.514 678.147L859.663 680.043Z",
    fill: "#9C9C9C"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M806.934 690.428L790.739 696.757L788.819 691.843L805.013 685.514L806.934 690.428Z",
    fill: "#9C9C9C"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M795.976 705.024L812.095 698.59L820.481 719.6L804.361 726.034L795.976 705.024ZM802.746 707.936L807.266 719.26L813.71 716.688L809.191 705.364L802.746 707.936Z",
    fill: "#9C9C9C"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M801.541 702.759L796.767 690.545L801.618 688.649L806.392 700.863L801.541 702.759Z",
    fill: "#9C9C9C"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M776.542 702.306L760.347 708.635L758.427 703.721L774.621 697.392L776.542 702.306Z",
    fill: "#9C9C9C"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M765.583 716.902L781.703 710.469L790.088 731.479L773.968 737.912L765.583 716.902ZM772.353 719.814L776.873 731.138L783.317 728.566L778.798 717.242L772.353 719.814Z",
    fill: "#9C9C9C"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M771.149 714.638L766.375 702.423L771.226 700.527L776 712.742L771.149 714.638Z",
    fill: "#9C9C9C"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M834.118 651.369L809.273 661.08L839.392 738.144L864.238 728.433L834.118 651.369Z",
    fill: "#9C9C9C"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M757.779 622.845L807.766 752.05L802.846 753.954L752.859 624.748L757.779 622.845Z",
    fill: "#9C9C9C"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M718.237 725.862L702.264 732.105L700.344 727.191L716.316 720.948L718.237 725.862Z",
    fill: "#9C9C9C"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M707.498 740.371L723.618 733.938L732.003 754.948L715.884 761.381L707.498 740.371ZM714.269 743.284L718.788 754.608L725.233 752.036L720.713 740.712L714.269 743.284Z",
    fill: "#9C9C9C"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M713.084 738.151L708.088 726.023L712.904 724.039L717.9 736.167L713.084 738.151Z",
    fill: "#9C9C9C"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M687.845 737.741L671.65 744.07L669.73 739.156L685.924 732.826L687.845 737.741Z",
    fill: "#9C9C9C"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M676.885 752.338L693.004 745.904L701.389 766.915L685.27 773.348L676.885 752.338ZM683.655 755.25L688.174 766.574L694.619 764.002L690.099 752.678L683.655 755.25Z",
    fill: "#9C9C9C"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M682.452 750.072L677.678 737.858L682.529 735.961L687.303 748.176L682.452 750.072Z",
    fill: "#9C9C9C"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M745.335 686.581L720.489 696.292L750.608 773.356L775.454 763.646L745.335 686.581Z",
    fill: "#9C9C9C"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M695.869 904.836L666.587 916.28L696.707 993.344L725.989 981.9L695.869 904.836Z",
    fill: "#9C9C9C"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M788.376 868.68L759.094 880.125L789.213 957.189L818.496 945.744L788.376 868.68Z",
    fill: "#9C9C9C"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M877.112 833.999L847.829 845.444L877.949 922.508L907.231 911.063L877.112 833.999Z",
    fill: "#9C9C9C"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M962.298 800.705L933.015 812.149L963.135 889.213L992.418 877.768L962.298 800.705Z",
    fill: "#9C9C9C"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M669.306 658.197L718.984 787.267L714.06 789.162L664.382 660.092L669.306 658.197Z",
    fill: "#9C9C9C"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M629.968 761.641L613.861 768.192L611.873 763.305L627.981 756.753L629.968 761.641Z",
    fill: "#9C9C9C"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M618.972 776.252L635.092 769.818L643.477 790.828L627.358 797.262L618.972 776.252ZM625.743 779.164L630.262 790.488L636.707 787.916L632.187 776.592L625.743 779.164Z",
    fill: "#9C9C9C"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M624.543 773.986L619.855 761.993L624.706 760.097L629.394 772.09L624.543 773.986Z",
    fill: "#9C9C9C"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M677.731 982.088L661.537 988.418L659.616 983.504L675.81 977.174L677.731 982.088Z",
    fill: "#9C9C9C"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M649.861 952.988L666.071 946.786L674.155 967.914L657.945 974.116L649.861 952.988ZM656.589 955.997L660.946 967.385L667.427 964.905L663.069 953.518L656.589 955.997Z",
    fill: "#9C9C9C"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M668.353 969.916L672.905 982.217L668.02 984.024L663.468 971.723L668.353 969.916Z",
    fill: "#9C9C9C"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1006.5 853.594L990.302 859.923L988.381 855.009L1004.58 848.679L1006.5 853.594Z",
    fill: "#9C9C9C"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M978.634 824.49L994.844 818.288L1002.93 839.416L986.718 845.618L978.634 824.49ZM985.362 827.499L989.719 838.886L996.2 836.407L991.843 825.019L985.362 827.499Z",
    fill: "#9C9C9C"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M997.101 841.376L1001.88 853.591L997.024 855.487L992.25 843.272L997.101 841.376Z",
    fill: "#9C9C9C"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M742.951 956.597L726.757 962.927L724.837 958.013L741.031 951.683L742.951 956.597Z",
    fill: "#9C9C9C"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M715.083 927.496L731.293 921.294L739.377 942.422L723.167 948.624L715.083 927.496ZM721.811 930.505L726.168 941.893L732.649 939.413L728.292 928.026L721.811 930.505Z",
    fill: "#9C9C9C"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M733.556 944.38L738.331 956.595L733.479 958.491L728.705 946.276L733.556 944.38Z",
    fill: "#9C9C9C"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M773.121 944.806L756.927 951.135L755.007 946.221L771.201 939.892L773.121 944.806Z",
    fill: "#9C9C9C"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M745.253 915.704L761.464 909.502L769.548 930.629L753.337 936.832L745.253 915.704ZM751.982 918.713L756.339 930.1L762.819 927.621L758.462 916.233L751.982 918.713Z",
    fill: "#9C9C9C"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M763.727 932.589L768.501 944.803L763.649 946.699L758.875 934.485L763.727 932.589Z",
    fill: "#9C9C9C"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M833.683 921.136L817.489 927.465L815.569 922.551L831.763 916.222L833.683 921.136Z",
    fill: "#9C9C9C"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M805.817 892.034L822.027 885.832L830.111 906.96L813.901 913.162L805.817 892.034ZM812.545 895.043L816.903 906.43L823.383 903.951L819.026 892.563L812.545 895.043Z",
    fill: "#9C9C9C"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M824.305 908.963L828.858 921.264L823.973 923.072L819.421 910.77L824.305 908.963Z",
    fill: "#9C9C9C"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M863.854 909.344L847.659 915.673L845.739 910.759L861.933 904.43L863.854 909.344Z",
    fill: "#9C9C9C"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M835.988 880.242L852.198 874.04L860.282 895.167L844.072 901.37L835.988 880.242ZM842.716 883.251L847.073 894.638L853.554 892.159L849.197 880.771L842.716 883.251Z",
    fill: "#9C9C9C"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M854.459 897.127L859.233 909.342L854.382 911.238L849.607 899.023L854.459 897.127Z",
    fill: "#9C9C9C"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M921.088 886.974L904.894 893.304L902.973 888.39L919.167 882.06L921.088 886.974Z",
    fill: "#9C9C9C"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M893.224 857.871L909.434 851.669L917.518 872.797L901.308 878.999L893.224 857.871ZM899.952 860.88L904.309 872.268L910.79 869.788L906.433 858.4L899.952 860.88Z",
    fill: "#9C9C9C"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M911.693 874.757L916.467 886.972L911.616 888.868L906.842 876.653L911.693 874.757Z",
    fill: "#9C9C9C"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M951.258 875.183L935.286 881.425L933.365 876.511L949.337 870.269L951.258 875.183Z",
    fill: "#9C9C9C"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M923.395 846.079L939.605 839.877L947.689 861.005L931.479 867.207L923.395 846.079ZM930.123 849.088L934.48 860.475L940.961 857.996L936.604 846.608L930.123 849.088Z",
    fill: "#9C9C9C"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M941.863 862.966L946.637 875.18L941.786 877.076L937.012 864.862L941.863 862.966Z",
    fill: "#9C9C9C"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M599.577 773.519L583.469 780.07L581.481 775.183L597.589 768.632L599.577 773.519Z",
    fill: "#9C9C9C"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M588.58 788.131L604.699 781.697L613.084 802.707L596.965 809.141L588.58 788.131ZM595.35 791.043L599.869 802.367L606.314 799.795L601.794 788.471L595.35 791.043Z",
    fill: "#9C9C9C"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M594.151 785.864L589.463 773.872L594.315 771.976L599.002 783.968L594.151 785.864Z",
    fill: "#9C9C9C"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M657.12 722.595L632.274 732.306L662.394 809.37L687.24 799.659L657.12 722.595Z",
    fill: "#9C9C9C"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M465.076 824.687L445.88 843.22L503.297 902.784L522.493 884.251L465.076 824.687Z",
    fill: "#9C9C9C"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M580.781 694.071L630.768 823.277L625.847 825.18L575.86 695.975L580.781 694.071Z",
    fill: "#9C9C9C"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.333 1396.01L111.582 1412L106.674 1413.91L100.424 1397.92L105.333 1396.01Z",
    fill: "#9C9C9C"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.751 1406.81L113.277 1390.68L134.247 1382.27L140.721 1398.39L119.751 1406.81ZM122.642 1400.03L133.944 1395.49L131.356 1389.04L120.054 1393.58L122.642 1400.03Z",
    fill: "#9C9C9C"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.616 1401.17L105.501 1406.16L103.515 1401.34L115.629 1396.35L117.616 1401.17Z",
    fill: "#9C9C9C"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.211 1426.4L123.682 1442.3L118.801 1444.29L112.329 1428.38L117.211 1426.4Z",
    fill: "#9C9C9C"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.923 1437.25L125.45 1421.12L146.42 1412.7L152.893 1428.83L131.923 1437.25ZM134.814 1430.47L146.117 1425.93L143.529 1419.48L132.226 1424.02L134.814 1430.47Z",
    fill: "#9C9C9C"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.508 1431.6L117.615 1436.5L115.628 1431.68L127.52 1426.78L129.508 1431.6Z",
    fill: "#9C9C9C"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.553 1496.35L151.111 1512.48L146.229 1514.47L139.671 1498.34L144.553 1496.35Z",
    fill: "#9C9C9C"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.237 1507.27L152.764 1491.15L173.733 1482.73L180.207 1498.86L159.237 1507.27ZM162.128 1500.5L173.43 1495.96L170.842 1489.51L159.54 1494.05L162.128 1500.5Z",
    fill: "#9C9C9C"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.892 1501.79L144.913 1506.48L143.015 1501.62L154.994 1496.94L156.892 1501.79Z",
    fill: "#9C9C9C"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.8381 1445.15L166.813 1395L168.728 1399.92L39.7523 1450.07L37.8381 1445.15Z",
    fill: "#9C9C9C"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.5101 1546.64L206.572 1496.71L208.478 1501.64L79.4159 1551.57L77.5101 1546.64Z",
    fill: "#9C9C9C"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.7905 1580.62L219.853 1530.69L221.758 1535.62L92.6963 1585.55L90.7905 1580.62Z",
    fill: "#9C9C9C"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.377 1612.82L232.439 1562.89L234.344 1567.82L105.282 1617.75L103.377 1612.82Z",
    fill: "#9C9C9C"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.653 1646.8L245.628 1596.65L247.542 1601.57L118.567 1651.73L116.653 1646.8Z",
    fill: "#9C9C9C"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.586 1679.9L258.561 1629.74L260.476 1634.67L131.5 1684.82L129.586 1679.9Z",
    fill: "#9C9C9C"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.784 1713.65L271.846 1663.72L273.752 1668.65L144.69 1718.58L142.784 1713.65Z",
    fill: "#9C9C9C"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.453 1746.08L284.428 1695.92L286.342 1700.85L157.367 1751L155.453 1746.08Z",
    fill: "#9C9C9C"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.65 1779.83L297.712 1729.9L299.618 1734.83L170.556 1784.76L168.65 1779.83Z",
    fill: "#9C9C9C"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.1 1814.26L311.076 1764.11L312.99 1769.03L184.015 1819.18L182.1 1814.26Z",
    fill: "#9C9C9C"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.298 1848.01L324.36 1798.08L326.266 1803.01L197.204 1852.94L195.298 1848.01Z",
    fill: "#9C9C9C"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.884 1880.22L336.946 1830.29L338.852 1835.21L209.79 1885.14L207.884 1880.22Z",
    fill: "#9C9C9C"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.165 1914.2L350.227 1864.26L352.132 1869.19L223.071 1919.12L221.165 1914.2Z",
    fill: "#9C9C9C"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234.098 1947.29L363.16 1897.36L365.066 1902.28L236.004 1952.21L234.098 1947.29Z",
    fill: "#9C9C9C"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M258.688 1976.85L376.35 1931.11L378.263 1936.04L260.602 1981.77L258.688 1976.85Z",
    fill: "#9C9C9C"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M271.357 2009.27L388.931 1963.32L390.854 1968.24L273.279 2014.19L271.357 2009.27Z",
    fill: "#9C9C9C"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.876 2040.17L402.217 1997.3L404.129 2002.22L293.789 2045.09L291.876 2040.17Z",
    fill: "#9C9C9C"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303.681 2070.37L414.021 2027.5L415.934 2032.42L305.594 2075.29L303.681 2070.37Z",
    fill: "#9C9C9C"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M526.034 805.417L513.119 816.865L509.623 812.915L522.538 801.467L526.034 805.417Z",
    fill: "#9C9C9C"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M520.674 823.012L533.615 811.444L548.677 828.317L535.736 839.885L520.674 823.012ZM528.03 823.43L536.148 832.524L541.321 827.899L533.204 818.805L528.03 823.43Z",
    fill: "#9C9C9C"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M525.16 818.926L516.519 809.247L520.402 805.775L529.044 815.454L525.16 818.926Z",
    fill: "#9C9C9C"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M501.497 827.04L488.582 838.488L485.085 834.537L498 823.089L501.497 827.04Z",
    fill: "#9C9C9C"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M496.32 844.48L509.261 832.912L524.323 849.785L511.382 861.353L496.32 844.48ZM503.676 844.898L511.794 853.992L516.967 849.367L508.849 840.273L503.676 844.898Z",
    fill: "#9C9C9C"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M500.623 840.549L491.981 830.87L495.864 827.397L504.506 837.076L500.623 840.549Z",
    fill: "#9C9C9C"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M460.476 762.909L547.665 862.982L543.689 866.451L456.5 766.378L460.476 762.909Z",
    fill: "#9C9C9C"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M389.263 889.152L370.068 907.685L427.485 967.248L446.681 948.715L389.263 889.152Z",
    fill: "#9C9C9C"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M450.213 869.869L437.298 881.317L433.801 877.366L446.716 865.918L450.213 869.869Z",
    fill: "#9C9C9C"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M445.039 887.31L457.98 875.741L473.041 892.614L460.101 904.183L445.039 887.31ZM452.395 887.727L460.512 896.822L465.686 892.197L457.568 883.103L452.395 887.727Z",
    fill: "#9C9C9C"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M449.561 883.291L440.919 873.612L444.802 870.14L453.444 879.819L449.561 883.291Z",
    fill: "#9C9C9C"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M425.675 891.491L412.76 902.939L409.264 898.989L422.179 887.541L425.675 891.491Z",
    fill: "#9C9C9C"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M420.508 908.936L433.448 897.368L448.51 914.241L435.569 925.809L420.508 908.936ZM427.863 909.354L435.981 918.448L441.154 913.823L433.037 904.729L427.863 909.354Z",
    fill: "#9C9C9C"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M425.023 904.914L416.381 895.235L420.265 891.762L428.906 901.441L425.023 904.914Z",
    fill: "#9C9C9C"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M384.655 827.36L471.844 927.433L467.868 930.902L380.679 830.829L384.655 827.36Z",
    fill: "#9C9C9C"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M319.566 956.851L300.371 975.384L357.788 1034.95L376.983 1016.41L319.566 956.851Z",
    fill: "#9C9C9C"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M380.516 937.559L367.601 949.007L364.104 945.057L377.019 933.608L380.516 937.559Z",
    fill: "#9C9C9C"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M375.342 955.001L388.283 943.432L403.344 960.305L390.403 971.874L375.342 955.001ZM382.697 955.418L390.815 964.513L395.989 959.888L387.871 950.793L382.697 955.418Z",
    fill: "#9C9C9C"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M379.864 950.981L371.222 941.302L375.105 937.83L383.747 947.509L379.864 950.981Z",
    fill: "#9C9C9C"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M355.978 959.182L343.063 970.63L339.567 966.679L352.482 955.231L355.978 959.182Z",
    fill: "#9C9C9C"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M350.81 976.627L363.751 965.059L378.813 981.932L365.872 993.5L350.81 976.627ZM358.166 977.045L366.284 986.139L371.457 981.514L363.339 972.42L358.166 977.045Z",
    fill: "#9C9C9C"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M355.326 972.604L346.684 962.925L350.568 959.453L359.209 969.132L355.326 972.604Z",
    fill: "#9C9C9C"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M314.955 895.047L402.366 995.034L398.396 998.509L310.985 898.523L314.955 895.047Z",
    fill: "#9C9C9C"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303.663 1007.63L292.416 1020.73L288.417 1017.29L299.664 1004.19L303.663 1007.63Z",
    fill: "#9C9C9C"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M300.793 1025.68L312.086 1012.49L329.25 1027.22L317.956 1040.4L300.793 1025.68ZM308.139 1025.11L317.389 1033.05L321.904 1027.78L312.653 1019.84L308.139 1025.11Z",
    fill: "#9C9C9C"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.795 1020.87L294.861 1012.46L298.222 1008.48L308.156 1016.89L304.795 1020.87Z",
    fill: "#9C9C9C"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M282.309 1032.09L271.15 1045.41L267.109 1042.02L278.269 1028.7L282.309 1032.09Z",
    fill: "#9C9C9C"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M279.321 1050.15L290.614 1036.97L307.778 1051.69L296.484 1064.88L279.321 1050.15ZM286.667 1049.59L295.917 1057.53L300.432 1052.26L291.181 1044.32L286.667 1049.59Z",
    fill: "#9C9C9C"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M283.286 1045.66L273.352 1037.26L276.713 1033.28L286.647 1041.68L283.286 1045.66Z",
    fill: "#9C9C9C"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.985 969.211L333.016 1061.87L329.335 1065.65L234.305 972.992L237.985 969.211Z",
    fill: "#9C9C9C"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M188.163 1118.29L173.156 1140.35L241.5 1186.94L256.508 1164.88L188.163 1118.29Z",
    fill: "#9C9C9C"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M243.742 1086.75L233.595 1100.7L229.333 1097.59L239.48 1083.64L243.742 1086.75Z",
    fill: "#9C9C9C"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242.197 1104.81L252.503 1090.84L270.687 1104.28L260.381 1118.25L242.197 1104.81ZM249.481 1103.71L259.283 1110.96L263.403 1105.37L253.602 1098.13L249.481 1103.71Z",
    fill: "#9C9C9C"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245.765 1099.91L235.339 1092.21L238.43 1088.02L248.857 1095.72L245.765 1099.91Z",
    fill: "#9C9C9C"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.829 1059.4L276.984 1138.76L273.789 1142.96L169.634 1063.6L172.829 1059.4Z",
    fill: "#9C9C9C"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M125.813 1208.76L110.805 1230.83L178.952 1277.28L193.96 1255.22L125.813 1208.76Z",
    fill: "#9C9C9C"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.459 1177.41L171.225 1191.14L167.007 1187.99L177.241 1174.26L181.459 1177.41Z",
    fill: "#9C9C9C"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.846 1195.58L190.146 1181.62L208.323 1195.05L198.023 1209.02L179.846 1195.58ZM187.117 1194.49L196.926 1201.74L201.052 1196.15L191.243 1188.9L187.117 1194.49Z",
    fill: "#9C9C9C"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.507 1190.55L173.081 1182.85L176.166 1178.66L186.593 1186.36L183.507 1190.55Z",
    fill: "#9C9C9C"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.963 1203.47L151.508 1217.29L147.313 1214.11L157.769 1200.29L161.963 1203.47Z",
    fill: "#9C9C9C"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.314 1221.6L170.614 1207.64L188.791 1221.07L178.491 1235.04L160.314 1221.6ZM167.585 1220.51L177.394 1227.76L181.52 1222.17L171.711 1214.92L167.585 1220.51Z",
    fill: "#9C9C9C"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.801 1216.68L153.375 1208.98L156.461 1204.8L166.887 1212.5L163.801 1216.68Z",
    fill: "#9C9C9C"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.529 1248.73L107.296 1262.46L103.078 1259.31L113.312 1245.58L117.529 1248.73Z",
    fill: "#9C9C9C"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.053 1266.74L126.354 1252.78L144.53 1266.21L134.23 1280.18L116.053 1266.74ZM123.324 1265.65L133.133 1272.9L137.259 1267.31L127.45 1260.06L123.324 1265.65Z",
    fill: "#9C9C9C"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.578 1261.87L109.151 1254.17L112.237 1249.99L122.663 1257.69L119.578 1261.87Z",
    fill: "#9C9C9C"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.791 1149.96L214.416 1229.27L211.218 1233.46L107.593 1154.15L110.791 1149.96Z",
    fill: "#9C9C9C"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M521.287 778.757L574.777 842.334L599.806 831.784L573.313 760.727L521.287 778.757Z",
    fill: "#9C9C9C"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1202.04 463.965L2208.63 89.0671L2211.96 98.0051L1214.37 469.552L1252.39 569.346L1243.49 572.738L1202.04 463.965Z",
    fill: "#9C9C9C"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1528 1270.6C16.1528 1270.6 -0.910002 1298.26 1.7034 1315.41C4.3168 1332.57 4.74099 1340.85 4.74099 1340.85C4.74099 1340.85 40.3221 1321.31 44.5754 1332.2C48.8286 1343.08 68.1851 1392.6 68.1851 1392.6L139.829 1365.88L148.637 1306.63L90.5649 1258.15C90.5649 1258.15 57.2307 1290.64 43.8626 1291.77C30.4945 1292.9 20.5604 1278.6 16.1528 1270.6Z",
    fill: "#9C9C9C"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.5559 1328.73C45.5559 1328.73 45.5586 1328.73 44.2667 1332.06L45.5586 1328.73L47.0289 1329.3L332.626 2067.27L332.415 2067.35L393.975 2224.86L358.41 2229.41L299.223 2076.65L220.242 1917.08L220.195 1916.97L223.497 1915.61C220.195 1916.97 220.194 1916.97 220.193 1916.97L219.537 1915.38C219.103 1914.33 218.46 1912.77 217.621 1910.73C215.943 1906.67 213.484 1900.7 210.358 1893.09C204.106 1877.88 195.186 1856.13 184.514 1829.96C163.171 1777.64 134.819 1707.65 106.788 1637.04C78.7595 1566.43 51.0405 1495.16 30.968 1440.27C20.9345 1412.83 12.7942 1389.44 7.47976 1372.26C4.82575 1363.68 2.85322 1356.57 1.70533 1351.25C1.13323 1348.59 0.745067 1346.29 0.594481 1344.42C0.519214 1343.49 0.496407 1342.59 0.562102 1341.76C0.623743 1340.99 0.781655 1340.01 1.24992 1339.09C7.33338 1327.17 19.1188 1324.88 28.3484 1325.26C33.0171 1325.45 37.2961 1326.31 40.3849 1327.12C41.9369 1327.52 43.2074 1327.92 44.0992 1328.21C44.5455 1328.36 44.8982 1328.48 45.1452 1328.57C45.2687 1328.62 45.3659 1328.65 45.4353 1328.68L45.5183 1328.71L45.5526 1328.72L45.5559 1328.73ZM226.142 1912.65C225.708 1911.6 225.065 1910.04 224.227 1908.01C222.55 1903.94 220.092 1897.98 216.967 1890.37C210.717 1875.17 201.799 1853.42 191.13 1827.26C169.792 1774.95 141.45 1704.99 113.429 1634.4C85.4068 1563.8 57.7169 1492.61 37.6788 1437.82C27.657 1410.41 19.5665 1387.16 14.3066 1370.15C11.6734 1361.63 9.77292 1354.76 8.69088 1349.74C8.14801 1347.22 7.83196 1345.27 7.71775 1343.85C7.66062 1343.15 7.66088 1342.65 7.68607 1342.33C7.69155 1342.27 7.69765 1342.21 7.70294 1342.17C11.9265 1334.09 20.0017 1332.08 28.0623 1332.41C32.0669 1332.57 35.8186 1333.32 38.5921 1334.04C39.7889 1334.35 40.7895 1334.65 41.5328 1334.89L323.389 2063.2L323.156 2063.29L383.985 2218.92L363.049 2221.61L305.769 2073.76L226.757 1914.14L226.142 1912.65Z",
    fill: "#9C9C9C"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M172.66 1435.49L90.3573 1467.65L102.683 1499.19L184.985 1467.02L172.66 1435.49Z",
    fill: "#9C9C9C"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.9243 1395.7L88.57 1393.07L353.338 2063.34L591.071 2012.91L591.122 2012.9L591.763 2016.42C591.122 2012.9 591.126 2012.9 591.126 2012.9L591.13 2012.9L591.139 2012.9L591.163 2012.9L591.232 2012.88C591.288 2012.87 591.363 2012.86 591.455 2012.85C591.639 2012.82 591.895 2012.79 592.215 2012.75C592.854 2012.68 593.752 2012.6 594.847 2012.57C597.026 2012.51 600.04 2012.63 603.362 2013.38C610.081 2014.89 618.119 2019 622.811 2029.14L622.844 2029.21L641.772 2075.19L1052.33 1911.93L1052.76 1911.87L1053.25 1915.42C1052.76 1911.87 1052.76 1911.87 1052.76 1911.87L1052.76 1911.87L1052.77 1911.87L1052.9 1911.86C1052.97 1911.85 1053.09 1911.83 1053.23 1911.82C1053.51 1911.78 1053.91 1911.74 1054.42 1911.7C1055.43 1911.61 1056.87 1911.52 1058.64 1911.49C1062.15 1911.43 1066.98 1911.61 1072.23 1912.62C1082.67 1914.62 1095.33 1920.02 1101.85 1933.79C1107.75 1946.23 1112.59 1958.62 1115.95 1967.87C1117.63 1972.5 1118.95 1976.36 1119.84 1979.07C1119.91 1979.28 1119.98 1979.48 1120.04 1979.68L2898.06 1282.71L2900.67 1289.37L1115.52 1989.13L1114.39 1985.45L1114.39 1985.45C1114.39 1985.45 1114.39 1985.45 1114.39 1985.45L1114.39 1985.44L1114.39 1985.43L1114.37 1985.38L1114.31 1985.18C1114.25 1985 1114.17 1984.73 1114.06 1984.38C1113.95 1984.06 1113.83 1983.68 1113.68 1983.23C1113.51 1982.68 1113.3 1982.04 1113.06 1981.31C1112.18 1978.66 1110.89 1974.87 1109.23 1970.31C1105.92 1961.18 1101.17 1949.02 1095.4 1936.85C1090.25 1925.99 1080.22 1921.43 1070.89 1919.64C1066.26 1918.75 1061.94 1918.58 1058.77 1918.64C1057.19 1918.67 1055.91 1918.75 1055.03 1918.82C1054.66 1918.86 1054.36 1918.89 1054.15 1918.91L637.855 2084.45L616.296 2032.08C612.758 2024.49 606.913 2021.5 601.799 2020.35C599.199 2019.77 596.803 2019.67 595.055 2019.72C594.185 2019.74 593.489 2019.8 593.025 2019.86C592.918 2019.87 592.824 2019.88 592.743 2019.89C592.649 2019.9 592.572 2019.91 592.515 2019.92C592.48 2019.93 592.453 2019.93 592.432 2019.94L348.915 2071.59L81.9243 1395.7Z",
    fill: "#9C9C9C"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2803.67 1308.14L1116.04 1968.76L1114.44 1964.67L2802.07 1304.05L2803.67 1308.14Z",
    fill: "#9C9C9C"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1152.94 1973.02L1119.23 1891.99L1123.28 1890.3L1156.99 1971.33L1152.94 1973.02Z",
    fill: "#9C9C9C"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1190.88 1958.19L1157.16 1877.16L1161.21 1875.47L1194.93 1956.51L1190.88 1958.19Z",
    fill: "#9C9C9C"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1223.05 1945.62L1189.33 1864.59L1193.38 1862.9L1227.09 1943.94L1223.05 1945.62Z",
    fill: "#9C9C9C"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1260.98 1930.8L1227.26 1849.76L1231.31 1848.08L1265.03 1929.11L1260.98 1930.8Z",
    fill: "#9C9C9C"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1295.59 1917.27L1261.87 1836.24L1265.92 1834.55L1299.64 1915.58L1295.59 1917.27Z",
    fill: "#9C9C9C"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1333.52 1902.44L1299.8 1821.41L1303.85 1819.72L1337.57 1900.76L1333.52 1902.44Z",
    fill: "#9C9C9C"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1365.69 1889.87L1331.97 1808.84L1336.02 1807.15L1369.74 1888.19L1365.69 1889.87Z",
    fill: "#9C9C9C"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1403.62 1875.04L1369.9 1794.01L1373.95 1792.33L1407.67 1873.36L1403.62 1875.04Z",
    fill: "#9C9C9C"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M608.087 1898.46L574.678 1817.56L578.591 1815.95L612 1896.85L608.087 1898.46Z",
    fill: "#9C9C9C"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M643.583 1884.6L609.953 1803.78L613.861 1802.16L647.492 1882.97L643.583 1884.6Z",
    fill: "#9C9C9C"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M673.307 1872.97L639.899 1792.07L643.812 1790.46L677.22 1871.36L673.307 1872.97Z",
    fill: "#9C9C9C"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M735.789 1928.15L675.386 1778.18L679.313 1776.6L739.716 1926.57L735.789 1928.15Z",
    fill: "#9C9C9C"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M767.957 1915.58L707.332 1765.7L711.256 1764.11L771.882 1913.99L767.957 1915.58Z",
    fill: "#9C9C9C"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M803.451 1901.71L742.826 1751.83L746.751 1750.24L807.376 1900.12L803.451 1901.71Z",
    fill: "#9C9C9C"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M833.177 1890.09L772.773 1740.12L776.7 1738.54L837.104 1888.51L833.177 1890.09Z",
    fill: "#9C9C9C"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M868.671 1876.22L808.267 1726.25L812.194 1724.67L872.598 1874.63L868.671 1876.22Z",
    fill: "#9C9C9C"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M902.612 1862.95L842.209 1712.98L846.136 1711.4L906.539 1861.37L902.612 1862.95Z",
    fill: "#9C9C9C"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M934.78 1850.38L874.155 1700.5L878.079 1698.91L938.705 1848.79L934.78 1850.38Z",
    fill: "#9C9C9C"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M970.274 1836.51L909.649 1686.63L913.574 1685.04L974.199 1834.92L970.274 1836.51Z",
    fill: "#9C9C9C"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M999.999 1824.89L939.596 1674.92L943.523 1673.34L1003.93 1823.31L999.999 1824.89Z",
    fill: "#9C9C9C"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1035.49 1811.02L975.09 1661.05L979.017 1659.47L1039.42 1809.43L1035.49 1811.02Z",
    fill: "#9C9C9C"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1070.99 1797.14L1010.58 1647.17L1014.51 1645.59L1074.91 1795.56L1070.99 1797.14Z",
    fill: "#9C9C9C"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1103.16 1784.57L1042.53 1634.69L1046.45 1633.1L1107.08 1782.99L1103.16 1784.57Z",
    fill: "#9C9C9C"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1138.65 1770.7L1078.02 1620.82L1081.95 1619.23L1142.57 1769.11L1138.65 1770.7Z",
    fill: "#9C9C9C"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1168.38 1759.08L1107.97 1609.11L1111.9 1607.53L1172.3 1757.5L1168.38 1759.08Z",
    fill: "#9C9C9C"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1203.87 1745.21L1143.47 1595.24L1147.39 1593.66L1207.8 1743.63L1203.87 1745.21Z",
    fill: "#9C9C9C"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1237.81 1731.94L1177.41 1581.97L1181.33 1580.39L1241.74 1730.36L1237.81 1731.94Z",
    fill: "#9C9C9C"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1269.98 1719.37L1209.35 1569.49L1213.28 1567.9L1273.9 1717.78L1269.98 1719.37Z",
    fill: "#9C9C9C"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1305.47 1705.5L1244.85 1555.62L1248.77 1554.03L1309.4 1703.91L1305.47 1705.5Z",
    fill: "#9C9C9C"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1335.2 1693.88L1274.79 1543.91L1278.72 1542.33L1339.13 1692.3L1335.2 1693.88Z",
    fill: "#9C9C9C"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1370.69 1680.01L1310.29 1530.04L1314.22 1528.46L1374.62 1678.42L1370.69 1680.01Z",
    fill: "#9C9C9C"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1399.31 1668.82L1338.69 1518.94L1342.61 1517.36L1403.24 1667.24L1399.31 1668.82Z",
    fill: "#9C9C9C"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1431.25 1656.34L1370.85 1506.37L1374.78 1504.79L1435.18 1654.75L1431.25 1656.34Z",
    fill: "#9C9C9C"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1466.75 1642.46L1406.34 1492.5L1410.27 1490.91L1470.68 1640.88L1466.75 1642.46Z",
    fill: "#9C9C9C"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1496.7 1630.76L1436.07 1480.88L1440 1479.29L1500.62 1629.17L1496.7 1630.76Z",
    fill: "#9C9C9C"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1532.19 1616.89L1471.57 1467.01L1475.49 1465.42L1536.12 1615.3L1532.19 1616.89Z",
    fill: "#9C9C9C"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1566.13 1603.62L1505.51 1453.74L1509.43 1452.15L1570.06 1602.04L1566.13 1603.62Z",
    fill: "#9C9C9C"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1598.08 1591.13L1537.67 1441.17L1541.6 1439.59L1602 1589.55L1598.08 1591.13Z",
    fill: "#9C9C9C"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1633.57 1577.26L1573.17 1427.29L1577.09 1425.71L1637.5 1575.68L1633.57 1577.26Z",
    fill: "#9C9C9C"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1663.52 1565.56L1602.9 1415.68L1606.82 1414.09L1667.45 1563.97L1663.52 1565.56Z",
    fill: "#9C9C9C"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1699.01 1551.69L1638.39 1401.81L1642.31 1400.22L1702.94 1550.1L1699.01 1551.69Z",
    fill: "#9C9C9C"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1732.96 1538.42L1672.33 1388.54L1676.26 1386.95L1736.88 1536.83L1732.96 1538.42Z",
    fill: "#9C9C9C"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1764.9 1525.93L1704.5 1375.97L1708.42 1374.38L1768.83 1524.35L1764.9 1525.93Z",
    fill: "#9C9C9C"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1800.39 1512.06L1739.99 1362.09L1743.92 1360.51L1804.32 1510.48L1800.39 1512.06Z",
    fill: "#9C9C9C"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1830.34 1500.36L1769.72 1350.48L1773.64 1348.89L1834.27 1498.77L1830.34 1500.36Z",
    fill: "#9C9C9C"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1865.84 1486.49L1805.21 1336.61L1809.14 1335.02L1869.76 1484.9L1865.84 1486.49Z",
    fill: "#9C9C9C"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1899.78 1473.22L1839.15 1323.34L1843.08 1321.75L1903.7 1471.63L1899.78 1473.22Z",
    fill: "#9C9C9C"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1931.72 1460.73L1871.32 1310.76L1875.25 1309.18L1935.65 1459.15L1931.72 1460.73Z",
    fill: "#9C9C9C"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1967.22 1446.86L1906.59 1296.98L1910.52 1295.39L1971.14 1445.28L1967.22 1446.86Z",
    fill: "#9C9C9C"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1997.17 1435.16L1936.54 1285.28L1940.47 1283.69L2001.09 1433.57L1997.17 1435.16Z",
    fill: "#9C9C9C"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2032.44 1421.37L1972.03 1271.4L1975.96 1269.82L2036.36 1419.79L2032.44 1421.37Z",
    fill: "#9C9C9C"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2061.06 1410.19L2000.43 1260.31L2004.36 1258.72L2064.98 1408.6L2061.06 1410.19Z",
    fill: "#9C9C9C"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2093.22 1397.62L2032.6 1247.73L2036.52 1246.15L2097.15 1396.03L2093.22 1397.62Z",
    fill: "#9C9C9C"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2128.72 1383.74L2068.09 1233.86L2072.02 1232.27L2132.64 1382.15L2128.72 1383.74Z",
    fill: "#9C9C9C"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2158.44 1372.12L2097.82 1222.24L2101.74 1220.66L2162.37 1370.54L2158.44 1372.12Z",
    fill: "#9C9C9C"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2193.94 1358.25L2133.31 1208.37L2137.24 1206.78L2197.86 1356.66L2193.94 1358.25Z",
    fill: "#9C9C9C"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2227.88 1344.99L2167.25 1195.11L2171.18 1193.52L2231.8 1343.4L2227.88 1344.99Z",
    fill: "#9C9C9C"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2260.05 1332.41L2199.42 1182.53L2203.34 1180.95L2263.97 1330.83L2260.05 1332.41Z",
    fill: "#9C9C9C"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2295.32 1318.63L2234.91 1168.66L2238.84 1167.08L2299.24 1317.04L2295.32 1318.63Z",
    fill: "#9C9C9C"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2325.27 1306.92L2264.64 1157.04L2268.57 1155.45L2329.19 1305.34L2325.27 1306.92Z",
    fill: "#9C9C9C"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2360.76 1293.05L2300.13 1143.17L2304.06 1141.58L2364.69 1291.46L2360.76 1293.05Z",
    fill: "#9C9C9C"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2399.58 1277.88L2338.96 1128L2342.88 1126.41L2403.51 1276.29L2399.58 1277.88Z",
    fill: "#9C9C9C"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2431.53 1265.39L2371.12 1115.42L2375.05 1113.84L2435.45 1263.81L2431.53 1265.39Z",
    fill: "#9C9C9C"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2467.02 1251.52L2406.62 1101.55L2410.54 1099.97L2470.95 1249.93L2467.02 1251.52Z",
    fill: "#9C9C9C"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2496.97 1239.81L2436.34 1089.93L2440.27 1088.35L2500.89 1238.23L2496.97 1239.81Z",
    fill: "#9C9C9C"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2532.46 1225.94L2471.84 1076.06L2475.76 1074.47L2536.39 1224.35L2532.46 1225.94Z",
    fill: "#9C9C9C"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2566.4 1212.68L2505.78 1062.8L2509.7 1061.21L2570.33 1211.09L2566.4 1212.68Z",
    fill: "#9C9C9C"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2598.35 1200.19L2537.95 1050.22L2541.87 1048.64L2602.28 1198.61L2598.35 1200.19Z",
    fill: "#9C9C9C"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2633.84 1186.32L2573.22 1036.44L2577.14 1034.85L2637.77 1184.73L2633.84 1186.32Z",
    fill: "#9C9C9C"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M476.082 1745.23L415.37 1595.13L419.294 1593.54L480.007 1743.64L476.082 1745.23Z",
    fill: "#9C9C9C"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M508.026 1732.74L447.535 1582.55L451.462 1580.97L511.953 1731.16L508.026 1732.74Z",
    fill: "#9C9C9C"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M543.52 1718.87L483.029 1568.68L486.957 1567.1L547.447 1717.29L543.52 1718.87Z",
    fill: "#9C9C9C"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M573.469 1707.17L512.757 1557.06L516.682 1555.48L577.394 1705.58L573.469 1707.17Z",
    fill: "#9C9C9C"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M608.963 1693.29L548.251 1543.19L552.176 1541.6L612.888 1691.71L608.963 1693.29Z",
    fill: "#9C9C9C"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M642.905 1680.03L582.193 1529.93L586.117 1528.34L646.829 1678.44L642.905 1680.03Z",
    fill: "#9C9C9C"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M674.848 1667.54L614.358 1517.35L618.285 1515.77L678.775 1665.96L674.848 1667.54Z",
    fill: "#9C9C9C"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M710.343 1653.67L649.852 1503.48L653.779 1501.9L714.27 1652.09L710.343 1653.67Z",
    fill: "#9C9C9C"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M740.292 1641.97L679.58 1491.86L683.505 1490.28L744.217 1640.38L740.292 1641.97Z",
    fill: "#9C9C9C"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M775.786 1628.09L715.074 1477.99L718.999 1476.4L779.711 1626.51L775.786 1628.09Z",
    fill: "#9C9C9C"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M804.18 1616.99L743.69 1466.8L747.617 1465.22L808.107 1615.41L804.18 1616.99Z",
    fill: "#9C9C9C"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M836.348 1604.42L775.636 1454.32L779.561 1452.73L840.273 1602.84L836.348 1604.42Z",
    fill: "#9C9C9C"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M871.842 1590.55L811.13 1440.45L815.055 1438.86L875.767 1588.96L871.842 1590.55Z",
    fill: "#9C9C9C"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M901.568 1578.93L841.077 1428.74L845.004 1427.16L905.495 1577.35L901.568 1578.93Z",
    fill: "#9C9C9C"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M937.063 1565.06L876.351 1414.96L880.276 1413.37L940.988 1563.47L937.063 1565.06Z",
    fill: "#9C9C9C"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M971.003 1551.79L910.513 1401.6L914.44 1400.02L974.93 1550.21L971.003 1551.79Z",
    fill: "#9C9C9C"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1003.17 1539.22L942.459 1389.12L946.384 1387.53L1007.1 1537.64L1003.17 1539.22Z",
    fill: "#9C9C9C"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1038.67 1525.35L977.953 1375.25L981.878 1373.66L1042.59 1523.76L1038.67 1525.35Z",
    fill: "#9C9C9C"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1068.39 1513.73L1007.68 1363.63L1011.6 1362.04L1072.32 1512.14L1068.39 1513.73Z",
    fill: "#9C9C9C"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1103.89 1499.86L1043.17 1349.76L1047.1 1348.17L1107.81 1498.27L1103.89 1499.86Z",
    fill: "#9C9C9C"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1142.71 1484.69L1082 1334.58L1085.92 1333L1146.63 1483.1L1142.71 1484.69Z",
    fill: "#9C9C9C"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1174.65 1472.2L1114.16 1322.01L1118.09 1320.43L1178.58 1470.62L1174.65 1472.2Z",
    fill: "#9C9C9C"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1210.15 1458.33L1149.66 1308.14L1153.58 1306.55L1214.07 1456.74L1210.15 1458.33Z",
    fill: "#9C9C9C"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1240.09 1446.62L1179.38 1296.52L1183.31 1294.93L1244.02 1445.04L1240.09 1446.62Z",
    fill: "#9C9C9C"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1275.59 1432.75L1214.88 1282.65L1218.8 1281.06L1279.51 1431.16L1275.59 1432.75Z",
    fill: "#9C9C9C"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1309.53 1419.48L1248.82 1269.38L1252.74 1267.79L1313.46 1417.9L1309.53 1419.48Z",
    fill: "#9C9C9C"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1341.47 1407L1280.98 1256.81L1284.91 1255.23L1345.4 1405.41L1341.47 1407Z",
    fill: "#9C9C9C"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1376.97 1393.12L1316.48 1242.93L1320.41 1241.35L1380.9 1391.54L1376.97 1393.12Z",
    fill: "#9C9C9C"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1405.74 1379.06L1345.25 1228.87L1349.18 1227.29L1409.67 1377.48L1405.74 1379.06Z",
    fill: "#9C9C9C"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1437.91 1366.49L1377.2 1216.39L1381.12 1214.8L1441.83 1364.91L1437.91 1366.49Z",
    fill: "#9C9C9C"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1473.4 1352.62L1412.69 1202.52L1416.61 1200.93L1477.33 1351.03L1473.4 1352.62Z",
    fill: "#9C9C9C"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1503.13 1341L1442.64 1190.81L1446.56 1189.23L1507.05 1339.42L1503.13 1341Z",
    fill: "#9C9C9C"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1538.62 1327.13L1478.13 1176.94L1482.06 1175.36L1542.55 1325.55L1538.62 1327.13Z",
    fill: "#9C9C9C"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1572.56 1313.86L1512.07 1163.67L1516 1162.09L1576.49 1312.28L1572.56 1313.86Z",
    fill: "#9C9C9C"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1604.73 1301.29L1544.02 1151.19L1547.94 1149.6L1608.66 1299.71L1604.73 1301.29Z",
    fill: "#9C9C9C"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1640.22 1287.42L1579.51 1137.32L1583.44 1135.73L1644.15 1285.83L1640.22 1287.42Z",
    fill: "#9C9C9C"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1669.95 1275.8L1609.46 1125.61L1613.39 1124.03L1673.88 1274.22L1669.95 1275.8Z",
    fill: "#9C9C9C"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1705.44 1261.93L1644.95 1111.74L1648.88 1110.15L1709.37 1260.34L1705.44 1261.93Z",
    fill: "#9C9C9C"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1734.06 1250.74L1673.35 1100.64L1677.28 1099.05L1737.99 1249.16L1734.06 1250.74Z",
    fill: "#9C9C9C"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1766.01 1238.26L1705.52 1088.07L1709.44 1086.48L1769.93 1236.67L1766.01 1238.26Z",
    fill: "#9C9C9C"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1801.5 1224.38L1741.01 1074.19L1744.94 1072.61L1805.43 1222.8L1801.5 1224.38Z",
    fill: "#9C9C9C"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1831.45 1212.68L1770.74 1062.58L1774.66 1060.99L1835.37 1211.09L1831.45 1212.68Z",
    fill: "#9C9C9C"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1866.94 1198.81L1806.23 1048.71L1810.16 1047.12L1870.87 1197.22L1866.94 1198.81Z",
    fill: "#9C9C9C"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1900.89 1185.54L1840.17 1035.44L1844.1 1033.85L1904.81 1183.96L1900.89 1185.54Z",
    fill: "#9C9C9C"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1932.83 1173.06L1872.34 1022.87L1876.27 1021.28L1936.76 1171.47L1932.83 1173.06Z",
    fill: "#9C9C9C"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1968.32 1159.18L1907.83 1008.99L1911.76 1007.41L1972.25 1157.6L1968.32 1159.18Z",
    fill: "#9C9C9C"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1998.27 1147.48L1937.56 997.377L1941.49 995.79L2002.2 1145.89L1998.27 1147.48Z",
    fill: "#9C9C9C"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2033.77 1133.61L1973.05 983.505L1976.98 981.917L2037.69 1132.02L2033.77 1133.61Z",
    fill: "#9C9C9C"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2072.37 1118.52L2011.88 968.329L2015.8 966.747L2076.29 1116.94L2072.37 1118.52Z",
    fill: "#9C9C9C"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2104.53 1105.95L2043.82 955.846L2047.75 954.259L2108.46 1104.36L2104.53 1105.95Z",
    fill: "#9C9C9C"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2140.03 1092.08L2079.32 941.974L2083.24 940.386L2143.95 1090.49L2140.03 1092.08Z",
    fill: "#9C9C9C"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2169.75 1080.46L2109.26 930.266L2113.19 928.684L2173.68 1078.87L2169.75 1080.46Z",
    fill: "#9C9C9C"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2205.25 1066.58L2144.76 916.393L2148.68 914.811L2209.17 1065L2205.25 1066.58Z",
    fill: "#9C9C9C"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2239.19 1053.32L2178.7 903.127L2182.63 901.546L2243.12 1051.74L2239.19 1053.32Z",
    fill: "#9C9C9C"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2271.36 1040.75L2210.64 890.645L2214.57 889.058L2275.28 1039.16L2271.36 1040.75Z",
    fill: "#9C9C9C"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2306.85 1026.88L2246.14 876.773L2250.06 875.185L2310.78 1025.29L2306.85 1026.88Z",
    fill: "#9C9C9C"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2335.13 1013.52L2274.73 863.548L2278.65 861.966L2339.06 1011.93L2335.13 1013.52Z",
    fill: "#9C9C9C"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2367.3 1000.95L2306.67 851.066L2310.6 849.478L2371.22 999.359L2367.3 1000.95Z",
    fill: "#9C9C9C"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2402.79 987.074L2342.17 837.193L2346.09 835.605L2406.72 985.487L2402.79 987.074Z",
    fill: "#9C9C9C"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2432.52 975.453L2372.11 825.485L2376.04 823.903L2436.44 973.871L2432.52 975.453Z",
    fill: "#9C9C9C"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2468.01 961.583L2407.39 811.702L2411.31 810.115L2471.94 959.996L2468.01 961.583Z",
    fill: "#9C9C9C"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2501.95 948.315L2441.55 798.347L2445.48 796.765L2505.88 946.733L2501.95 948.315Z",
    fill: "#9C9C9C"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2534.12 935.746L2473.49 785.865L2477.42 784.277L2538.04 934.158L2534.12 935.746Z",
    fill: "#9C9C9C"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M376.029 1491.2L315.625 1341.23L319.552 1339.65L379.956 1489.62L376.029 1491.2Z",
    fill: "#9C9C9C"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M408.197 1478.63L347.571 1328.75L351.496 1327.16L412.121 1477.04L408.197 1478.63Z",
    fill: "#9C9C9C"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M443.691 1464.76L383.065 1314.88L386.99 1313.29L447.616 1463.17L443.691 1464.76Z",
    fill: "#9C9C9C"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M473.416 1453.14L413.013 1303.17L416.94 1301.59L477.343 1451.55L473.416 1453.14Z",
    fill: "#9C9C9C"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M508.911 1439.27L448.286 1289.39L452.211 1287.8L512.836 1437.68L508.911 1439.27Z",
    fill: "#9C9C9C"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M542.853 1426L482.227 1276.12L486.152 1274.53L546.777 1424.41L542.853 1426Z",
    fill: "#9C9C9C"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M575.019 1413.43L514.394 1263.55L518.319 1261.96L578.944 1411.84L575.019 1413.43Z",
    fill: "#9C9C9C"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M610.514 1399.56L549.888 1249.67L553.813 1248.09L614.438 1397.97L610.514 1399.56Z",
    fill: "#9C9C9C"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M638.88 1386.42L578.255 1236.54L582.179 1234.95L642.805 1384.83L638.88 1386.42Z",
    fill: "#9C9C9C"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M671.047 1373.85L610.421 1223.97L614.346 1222.38L674.971 1372.26L671.047 1373.85Z",
    fill: "#9C9C9C"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M706.318 1360.06L645.914 1210.09L649.841 1208.51L710.245 1358.48L706.318 1360.06Z",
    fill: "#9C9C9C"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M736.267 1348.36L675.642 1198.48L679.567 1196.89L740.192 1346.77L736.267 1348.36Z",
    fill: "#9C9C9C"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M771.762 1334.49L711.136 1184.6L715.061 1183.02L775.686 1332.9L771.762 1334.49Z",
    fill: "#9C9C9C"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M805.703 1321.22L745.077 1171.34L749.002 1169.75L809.628 1319.63L805.703 1321.22Z",
    fill: "#9C9C9C"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M837.87 1308.65L777.244 1158.77L781.169 1157.18L841.794 1307.06L837.87 1308.65Z",
    fill: "#9C9C9C"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M871.617 1297.5L811.213 1147.53L815.14 1145.95L875.544 1295.92L871.617 1297.5Z",
    fill: "#9C9C9C"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M903.785 1284.93L843.159 1135.05L847.084 1133.46L907.709 1283.35L903.785 1284.93Z",
    fill: "#9C9C9C"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M939.279 1271.06L878.654 1121.18L882.578 1119.59L943.204 1269.47L939.279 1271.06Z",
    fill: "#9C9C9C"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M969.005 1259.44L908.38 1109.56L912.305 1107.97L972.93 1257.86L969.005 1259.44Z",
    fill: "#9C9C9C"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1004.5 1245.57L943.874 1095.69L947.799 1094.1L1008.42 1243.98L1004.5 1245.57Z",
    fill: "#9C9C9C"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1038.44 1232.3L977.815 1082.42L981.74 1080.84L1042.37 1230.72L1038.44 1232.3Z",
    fill: "#9C9C9C"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1070.61 1219.73L1009.98 1069.85L1013.91 1068.26L1074.53 1218.14L1070.61 1219.73Z",
    fill: "#9C9C9C"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1106.1 1205.86L1045.48 1055.98L1049.4 1054.39L1110.03 1204.27L1106.1 1205.86Z",
    fill: "#9C9C9C"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1134.47 1192.72L1073.84 1042.84L1077.77 1041.26L1138.39 1191.14L1134.47 1192.72Z",
    fill: "#9C9C9C"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1166.63 1180.15L1106.01 1030.27L1109.93 1028.68L1170.56 1178.57L1166.63 1180.15Z",
    fill: "#9C9C9C"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1201.91 1166.36L1141.5 1016.4L1145.43 1014.81L1205.83 1164.78L1201.91 1166.36Z",
    fill: "#9C9C9C"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1231.86 1154.66L1171.23 1004.78L1175.15 1003.19L1235.78 1153.07L1231.86 1154.66Z",
    fill: "#9C9C9C"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1438.23 1861.52L1404.29 1780.58L1408.34 1778.88L1442.28 1859.83L1438.23 1861.52Z",
    fill: "#9C9C9C"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1476.16 1846.69L1442.45 1765.66L1446.5 1763.97L1480.21 1845.01L1476.16 1846.69Z",
    fill: "#9C9C9C"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1508.33 1834.13L1474.39 1753.18L1478.44 1751.48L1512.38 1832.43L1508.33 1834.13Z",
    fill: "#9C9C9C"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1546.26 1819.29L1512.55 1738.26L1516.6 1736.57L1550.31 1817.61L1546.26 1819.29Z",
    fill: "#9C9C9C"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1580.87 1805.77L1546.93 1724.83L1550.98 1723.13L1584.92 1804.08L1580.87 1805.77Z",
    fill: "#9C9C9C"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1618.81 1790.94L1585.09 1709.91L1589.14 1708.22L1622.86 1789.26L1618.81 1790.94Z",
    fill: "#9C9C9C"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1650.97 1778.38L1617.04 1697.43L1621.08 1695.73L1655.02 1776.68L1650.97 1778.38Z",
    fill: "#9C9C9C"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1688.91 1763.54L1655.19 1682.51L1659.24 1680.82L1692.96 1761.86L1688.91 1763.54Z",
    fill: "#9C9C9C"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1722.19 1750.53L1688.47 1669.5L1692.51 1667.82L1726.22 1748.86L1722.19 1750.53Z",
    fill: "#9C9C9C"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1759.9 1735.79L1726.19 1654.76L1730.22 1653.08L1763.94 1734.12L1759.9 1735.79Z",
    fill: "#9C9C9C"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1791.63 1723.4L1757.91 1642.36L1761.94 1640.68L1795.66 1721.72L1791.63 1723.4Z",
    fill: "#9C9C9C"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1829.34 1708.66L1795.62 1627.62L1799.65 1625.95L1833.37 1706.98L1829.34 1708.66Z",
    fill: "#9C9C9C"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1863.5 1695.3L1829.79 1614.27L1833.82 1612.59L1867.53 1693.63L1863.5 1695.3Z",
    fill: "#9C9C9C"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1901.22 1680.56L1867.5 1599.53L1871.53 1597.85L1905.25 1678.89L1901.22 1680.56Z",
    fill: "#9C9C9C"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1932.94 1668.17L1899.22 1587.13L1903.25 1585.45L1936.97 1666.49L1932.94 1668.17Z",
    fill: "#9C9C9C"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1970.65 1653.43L1936.93 1572.39L1940.96 1570.72L1974.68 1651.75L1970.65 1653.43Z",
    fill: "#9C9C9C"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2003.05 1640.76L1969.33 1559.73L1973.34 1558.06L2007.06 1639.09L2003.05 1640.76Z",
    fill: "#9C9C9C"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2040.32 1626.2L2006.6 1545.16L2010.61 1543.49L2044.33 1624.53L2040.32 1626.2Z",
    fill: "#9C9C9C"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2071.82 1613.89L2038.1 1532.85L2042.11 1531.18L2075.83 1612.22L2071.82 1613.89Z",
    fill: "#9C9C9C"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2109.09 1599.32L2075.37 1518.29L2079.38 1516.62L2113.1 1597.65L2109.09 1599.32Z",
    fill: "#9C9C9C"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2142.81 1586.14L2109.09 1505.11L2113.1 1503.44L2146.82 1584.47L2142.81 1586.14Z",
    fill: "#9C9C9C"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2180.3 1571.49L2146.58 1490.45L2150.59 1488.78L2184.31 1569.82L2180.3 1571.49Z",
    fill: "#9C9C9C"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2211.58 1559.26L2177.86 1478.23L2181.87 1476.56L2215.59 1557.59L2211.58 1559.26Z",
    fill: "#9C9C9C"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2249.07 1544.61L2215.35 1463.58L2219.36 1461.91L2253.08 1542.94L2249.07 1544.61Z",
    fill: "#9C9C9C"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2285.89 1530.22L2252.18 1449.18L2256.19 1447.51L2289.91 1528.55L2285.89 1530.22Z",
    fill: "#9C9C9C"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2323.16 1515.65L2289.45 1434.62L2293.46 1432.95L2327.17 1513.98L2323.16 1515.65Z",
    fill: "#9C9C9C"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2354.66 1503.34L2320.95 1422.3L2324.96 1420.64L2358.68 1501.67L2354.66 1503.34Z",
    fill: "#9C9C9C"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2391.93 1488.77L2358.22 1407.74L2362.23 1406.07L2395.94 1487.1L2391.93 1488.77Z",
    fill: "#9C9C9C"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2425.65 1475.59L2391.94 1394.56L2395.95 1392.89L2429.66 1473.92L2425.65 1475.59Z",
    fill: "#9C9C9C"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2463.14 1460.94L2429.43 1379.91L2433.44 1378.24L2467.15 1459.27L2463.14 1460.94Z",
    fill: "#9C9C9C"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2494.42 1448.71L2460.71 1367.68L2464.72 1366.01L2498.43 1447.05L2494.42 1448.71Z",
    fill: "#9C9C9C"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2531.91 1434.06L2498.2 1353.03L2502.21 1351.36L2535.92 1432.39L2531.91 1434.06Z",
    fill: "#9C9C9C"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2567.41 1420.19L2533.47 1339.25L2537.48 1337.57L2571.42 1418.51L2567.41 1420.19Z",
    fill: "#9C9C9C"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2604.68 1405.62L2570.96 1324.59L2574.97 1322.92L2608.69 1403.95L2604.68 1405.62Z",
    fill: "#9C9C9C"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2635.96 1393.4L2602.24 1312.36L2606.25 1310.69L2639.97 1391.73L2635.96 1393.4Z",
    fill: "#9C9C9C"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2673.45 1378.75L2639.73 1297.71L2643.74 1296.04L2677.46 1377.08L2673.45 1378.75Z",
    fill: "#9C9C9C"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2707.17 1365.57L2673.45 1284.53L2677.46 1282.86L2711.18 1363.9L2707.17 1365.57Z",
    fill: "#9C9C9C"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2744.66 1350.92L2710.72 1269.97L2714.73 1268.29L2748.67 1349.24L2744.66 1350.92Z",
    fill: "#9C9C9C"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2775.94 1338.69L2742.22 1257.65L2746.23 1255.98L2779.95 1337.02L2775.94 1338.69Z",
    fill: "#9C9C9C"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2813.21 1324.12L2779.49 1243.09L2783.5 1241.42L2817.22 1322.45L2813.21 1324.12Z",
    fill: "#9C9C9C"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M574.028 1898.42L546.252 1827.35L459.957 1861.08C459.957 1861.08 437.483 1884.71 462.888 1906.53C488.293 1928.34 502.085 1923.72 537.049 1915.69C572.012 1907.66 598.643 1901.86 624.346 1913.31C650.272 1924.69 660.573 1937.3 679.004 1939.31C697.436 1941.33 704.757 1938.46 704.757 1938.46L675.418 1863.4L574.028 1898.42Z",
    fill: "#9C9C9C"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M2573.23 1030L2632.08 1180.58C2632.08 1180.58 2652.74 1174.55 2653.81 1161.59C2655.11 1148.54 2607.02 1031.39 2607.02 1031.39C2607.02 1031.39 2596.27 1018.95 2573.23 1030Z",
    fill: "#9C9C9C"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M2474.89 778.381L2533.74 928.956C2533.74 928.956 2554.4 922.929 2555.47 909.966C2556.76 896.916 2508.67 779.768 2508.67 779.768C2508.67 779.768 2497.93 767.327 2474.89 778.381Z",
    fill: "#9C9C9C"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M2380.28 536.307L2439.13 686.881C2439.13 686.881 2459.79 680.855 2460.86 667.892C2462.15 654.842 2414.06 537.694 2414.06 537.694C2414.06 537.694 2403.32 525.253 2380.28 536.307Z",
    fill: "#9C9C9C"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M1216.73 991.067L1275.58 1141.64C1275.58 1141.64 1296.24 1135.62 1297.31 1122.65C1298.6 1109.6 1250.52 992.455 1250.52 992.455C1250.52 992.455 1239.55 980.1 1216.73 991.067Z",
    fill: "#9C9C9C"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M674.677 1860.85L2625.01 1097.05L2626.93 1101.97L676.603 1865.77L674.677 1860.85Z",
    fill: "#9C9C9C"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M411.332 1679.09L2528.49 850.09L2530.41 855.008L413.258 1684.01L411.332 1679.09Z",
    fill: "#9C9C9C"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1251.14 1061.39L312.587 1433.59L309.739 1426.41L1248.29 1054.2L1251.14 1061.39Z",
    fill: "#9C9C9C"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1541.57 1035.66L1480.95 885.78L1484.87 884.192L1545.5 1034.07L1541.57 1035.66Z",
    fill: "#9C9C9C"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1573.52 1023.17L1513.11 873.205L1517.04 871.623L1577.44 1021.59L1573.52 1023.17Z",
    fill: "#9C9C9C"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1609.01 1009.3L1548.61 859.332L1552.53 857.75L1612.94 1007.72L1609.01 1009.3Z",
    fill: "#9C9C9C"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1638.96 997.598L1578.33 847.717L1582.26 846.129L1642.88 996.01L1638.96 997.598Z",
    fill: "#9C9C9C"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1674.23 983.809L1613.83 833.841L1617.75 832.26L1678.16 982.227L1674.23 983.809Z",
    fill: "#9C9C9C"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1708.39 970.459L1647.77 820.579L1651.69 818.991L1712.32 968.872L1708.39 970.459Z",
    fill: "#9C9C9C"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1740.34 957.971L1679.93 808.004L1683.86 806.422L1744.26 956.389L1740.34 957.971Z",
    fill: "#9C9C9C"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1775.83 944.102L1715.21 794.221L1719.13 792.633L1779.76 942.514L1775.83 944.102Z",
    fill: "#9C9C9C"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1442.63 1074.33L1382.01 924.45L1385.93 922.862L1446.56 1072.74L1442.63 1074.33Z",
    fill: "#9C9C9C"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1474.57 1061.84L1414.17 911.875L1418.1 910.293L1478.5 1060.26L1474.57 1061.84Z",
    fill: "#9C9C9C"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1510.07 1047.97L1449.67 898.002L1453.59 896.42L1514 1046.39L1510.07 1047.97Z",
    fill: "#9C9C9C"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1540.02 1036.27L1479.39 886.387L1483.32 884.799L1543.94 1034.68L1540.02 1036.27Z",
    fill: "#9C9C9C"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1575.51 1022.39L1514.89 872.514L1518.81 870.926L1579.44 1020.81L1575.51 1022.39Z",
    fill: "#9C9C9C"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1609.45 1009.13L1548.83 859.248L1552.75 857.661L1613.38 1007.54L1609.45 1009.13Z",
    fill: "#9C9C9C"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1641.4 996.641L1580.99 846.673L1584.92 845.092L1645.32 995.059L1641.4 996.641Z",
    fill: "#9C9C9C"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1676.89 982.768L1616.49 832.801L1620.42 831.219L1680.82 981.187L1676.89 982.768Z",
    fill: "#9C9C9C"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1804.2 930.964L1743.79 780.996L1747.72 779.414L1808.13 929.382L1804.2 930.964Z",
    fill: "#9C9C9C"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1836.37 918.395L1775.74 768.514L1779.67 766.926L1840.29 916.807L1836.37 918.395Z",
    fill: "#9C9C9C"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1871.86 904.522L1811.24 754.641L1815.16 753.054L1875.79 902.935L1871.86 904.522Z",
    fill: "#9C9C9C"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1901.59 892.901L1841.18 742.933L1845.11 741.352L1905.51 891.319L1901.59 892.901Z",
    fill: "#9C9C9C"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1937.08 879.028L1876.68 729.061L1880.6 727.479L1941.01 877.447L1937.08 879.028Z",
    fill: "#9C9C9C"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1971.02 865.763L1910.62 715.795L1914.54 714.213L1974.95 864.181L1971.02 865.763Z",
    fill: "#9C9C9C"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2003.19 853.194L1942.56 703.313L1946.49 701.725L2007.11 851.606L2003.19 853.194Z",
    fill: "#9C9C9C"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2037.16 841.965L1976.53 692.084L1980.46 690.496L2041.08 840.377L2037.16 841.965Z",
    fill: "#9C9C9C"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2069.1 829.477L2008.7 679.509L2012.63 677.927L2073.03 827.895L2069.1 829.477Z",
    fill: "#9C9C9C"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2104.6 815.604L2044.19 665.636L2048.12 664.055L2108.52 814.022L2104.6 815.604Z",
    fill: "#9C9C9C"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2134.55 803.902L2073.92 654.021L2077.85 652.433L2138.47 802.314L2134.55 803.902Z",
    fill: "#9C9C9C"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2169.82 790.113L2109.41 640.146L2113.34 638.564L2173.74 788.531L2169.82 790.113Z",
    fill: "#9C9C9C"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2203.98 776.764L2143.36 626.883L2147.28 625.295L2207.91 775.176L2203.98 776.764Z",
    fill: "#9C9C9C"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2235.93 764.275L2175.52 614.308L2179.45 612.726L2239.85 762.694L2235.93 764.275Z",
    fill: "#9C9C9C"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2271.42 750.406L2210.8 600.525L2214.72 598.937L2275.35 748.818L2271.42 750.406Z",
    fill: "#9C9C9C"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2299.79 737.268L2239.38 587.3L2243.31 585.718L2303.71 735.686L2299.79 737.268Z",
    fill: "#9C9C9C"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2331.95 724.699L2271.33 574.818L2275.25 573.23L2335.88 723.111L2331.95 724.699Z",
    fill: "#9C9C9C"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2367.45 710.826L2306.82 560.945L2310.75 559.358L2371.37 709.239L2367.45 710.826Z",
    fill: "#9C9C9C"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2397.17 699.205L2336.77 549.237L2340.7 547.656L2401.1 697.623L2397.17 699.205Z",
    fill: "#9C9C9C"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M1382.68 924.929L1441.53 1075.5C1441.53 1075.5 1422.26 1085.08 1412.68 1076.28C1402.88 1067.57 1358.78 948.859 1358.78 948.859C1358.78 948.859 1358.16 932.207 1382.68 924.929Z",
    fill: "#9C9C9C"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M2279.23 284.97L2338.08 435.545C2338.08 435.545 2358.74 429.518 2359.81 416.555C2360.88 403.592 2313.02 286.357 2313.02 286.357C2313.02 286.357 2302.05 274.003 2279.23 284.97Z",
    fill: "#9C9C9C"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2416.46 605.931L1410.02 1004.66L1407.18 997.482L2413.61 598.75L2416.46 605.931Z",
    fill: "#9C9C9C"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1445.83 790.699L1385.21 640.818L1389.13 639.231L1449.76 789.112L1445.83 790.699Z",
    fill: "#9C9C9C"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1477.77 778.211L1417.37 628.243L1421.3 626.662L1481.7 776.629L1477.77 778.211Z",
    fill: "#9C9C9C"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1513.27 764.338L1452.86 614.371L1456.79 612.789L1517.2 762.757L1513.27 764.338Z",
    fill: "#9C9C9C"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1543.22 752.636L1482.59 602.755L1486.52 601.168L1547.14 751.049L1543.22 752.636Z",
    fill: "#9C9C9C"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1578.49 738.848L1518.09 588.88L1522.01 587.298L1582.42 737.266L1578.49 738.848Z",
    fill: "#9C9C9C"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1612.65 725.498L1552.03 575.617L1555.95 574.03L1616.58 723.911L1612.65 725.498Z",
    fill: "#9C9C9C"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1644.6 713.01L1584.19 563.042L1588.12 561.46L1648.52 711.428L1644.6 713.01Z",
    fill: "#9C9C9C"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1680.09 699.14L1619.47 549.259L1623.39 547.672L1684.02 697.553L1680.09 699.14Z",
    fill: "#9C9C9C"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1346.89 829.369L1286.27 679.488L1290.19 677.9L1350.82 827.781L1346.89 829.369Z",
    fill: "#9C9C9C"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1378.83 816.881L1318.43 666.913L1322.36 665.331L1382.76 815.299L1378.83 816.881Z",
    fill: "#9C9C9C"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1414.33 803.008L1353.92 653.041L1357.85 651.459L1418.26 801.426L1414.33 803.008Z",
    fill: "#9C9C9C"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1444.28 791.306L1383.65 641.425L1387.58 639.838L1448.2 789.719L1444.28 791.306Z",
    fill: "#9C9C9C"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1479.77 777.434L1419.15 627.553L1423.07 625.965L1483.7 775.846L1479.77 777.434Z",
    fill: "#9C9C9C"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1513.71 764.168L1453.09 614.287L1457.01 612.699L1517.64 762.58L1513.71 764.168Z",
    fill: "#9C9C9C"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1545.66 751.68L1485.25 601.712L1489.18 600.13L1549.58 750.098L1545.66 751.68Z",
    fill: "#9C9C9C"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1581.15 737.807L1520.75 587.839L1524.67 586.258L1585.08 736.225L1581.15 737.807Z",
    fill: "#9C9C9C"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1708.46 686.003L1647.97 535.813L1651.89 534.231L1712.38 684.421L1708.46 686.003Z",
    fill: "#9C9C9C"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1740.63 673.433L1679.91 523.33L1683.84 521.743L1744.55 671.846L1740.63 673.433Z",
    fill: "#9C9C9C"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1776.12 659.561L1715.41 509.458L1719.33 507.87L1780.04 657.973L1776.12 659.561Z",
    fill: "#9C9C9C"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1805.84 647.94L1745.35 497.75L1749.28 496.168L1809.77 646.358L1805.84 647.94Z",
    fill: "#9C9C9C"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1841.34 634.067L1780.85 483.877L1784.78 482.296L1845.27 632.485L1841.34 634.067Z",
    fill: "#9C9C9C"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1875.28 620.801L1814.79 470.612L1818.72 469.03L1879.21 619.22L1875.28 620.801Z",
    fill: "#9C9C9C"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1907.45 608.232L1846.74 458.129L1850.66 456.542L1911.37 606.645L1907.45 608.232Z",
    fill: "#9C9C9C"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1941.42 597.003L1880.79 447.122L1884.72 445.535L1945.34 595.416L1941.42 597.003Z",
    fill: "#9C9C9C"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1973.36 584.515L1912.96 434.548L1916.89 432.966L1977.29 582.933L1973.36 584.515Z",
    fill: "#9C9C9C"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2008.86 570.643L1948.45 420.675L1952.38 419.093L2012.78 569.061L2008.86 570.643Z",
    fill: "#9C9C9C"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2038.81 558.941L1978.18 409.06L1982.11 407.472L2042.73 557.353L2038.81 558.941Z",
    fill: "#9C9C9C"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2074.08 545.152L2013.67 395.184L2017.6 393.602L2078 543.57L2074.08 545.152Z",
    fill: "#9C9C9C"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2108.24 531.802L2047.62 381.921L2051.54 380.334L2112.17 530.215L2108.24 531.802Z",
    fill: "#9C9C9C"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2140.19 519.314L2079.78 369.346L2083.71 367.765L2144.11 517.732L2140.19 519.314Z",
    fill: "#9C9C9C"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2175.68 505.444L2115.05 355.563L2118.98 353.976L2179.61 503.857L2175.68 505.444Z",
    fill: "#9C9C9C"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2204.05 492.307L2143.56 342.117L2147.48 340.535L2207.97 490.725L2204.05 492.307Z",
    fill: "#9C9C9C"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2236.21 479.737L2175.5 329.634L2179.43 328.047L2240.14 478.15L2236.21 479.737Z",
    fill: "#9C9C9C"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2271.71 465.865L2211 315.762L2214.92 314.174L2275.63 464.277L2271.71 465.865Z",
    fill: "#9C9C9C"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2301.43 454.244L2240.94 304.054L2244.87 302.472L2305.36 452.662L2301.43 454.244Z",
    fill: "#9C9C9C"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2320.63 360.747L1314.28 759.701L1311.44 752.521L2317.78 353.567L2320.63 360.747Z",
    fill: "#9C9C9C"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M658.56 1006.97L630.562 930.104L614.146 936.52L447.34 1087.48C447.34 1087.48 397.04 1140.68 383.797 1160.44C370.554 1180.21 374.508 1195.56 374.508 1195.56C374.508 1195.56 385.773 1197.56 413.532 1188.76C441.513 1179.87 480.527 1162.58 480.527 1162.58L453.378 1090.5L658.56 1006.97Z",
    fill: "#9C9C9C"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M1157.31 792.584C1172.63 786.599 1180.18 769.317 1174.19 753.985C1168.2 738.654 1150.93 731.077 1135.61 737.063C1120.3 743.048 1112.74 760.329 1118.73 775.661C1124.72 790.993 1142 798.57 1157.31 792.584Z",
    fill: "white"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1136.57 739.522C1122.62 744.978 1115.73 760.728 1121.19 774.701C1126.65 788.674 1142.39 795.58 1156.35 790.124C1170.31 784.669 1177.2 768.919 1171.73 754.946C1166.27 740.972 1150.53 734.067 1136.57 739.522ZM1116.28 776.622C1109.75 759.931 1117.98 741.119 1134.65 734.603C1151.32 728.087 1170.13 736.335 1176.65 753.025C1183.17 769.715 1174.95 788.528 1158.27 795.044C1141.6 801.56 1122.8 793.312 1116.28 776.622Z",
    fill: "#9C9C9C"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M1185.61 864.984C1200.92 858.999 1208.48 841.717 1202.49 826.386C1196.5 811.054 1179.22 803.477 1163.91 809.463C1148.59 815.448 1141.04 832.73 1147.03 848.061C1153.02 863.393 1170.29 870.97 1185.61 864.984Z",
    fill: "white"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1164.87 811.922C1150.91 817.378 1144.02 833.128 1149.49 847.101C1154.95 861.075 1170.69 867.98 1184.65 862.525C1198.61 857.069 1205.49 841.319 1200.03 827.346C1194.57 813.372 1178.83 806.467 1164.87 811.922ZM1144.57 849.022C1138.05 832.331 1146.28 813.519 1162.95 807.003C1179.62 800.487 1198.42 808.735 1204.95 825.425C1211.47 842.116 1203.24 860.928 1186.57 867.444C1169.9 873.96 1151.1 865.712 1144.57 849.022Z",
    fill: "#9C9C9C"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1113.02 735.65L1116.39 734.335C1132.69 727.963 1144.5 730.038 1152.35 734.14C1156.21 736.155 1158.99 738.598 1160.82 740.552C1161.74 741.531 1162.42 742.393 1162.89 743.03C1163.12 743.349 1163.3 743.613 1163.43 743.807C1163.49 743.904 1163.54 743.984 1163.58 744.045L1163.63 744.123L1163.65 744.162L1163.65 744.167C1163.66 744.169 1163.66 744.171 1160.58 745.992C1163.93 744.747 1163.93 744.748 1163.93 744.748L1165.66 749.393C1166.76 752.357 1168.34 756.601 1170.25 761.722C1174.06 771.965 1179.18 785.716 1184.41 799.752C1194.88 827.851 1205.77 857.018 1207.53 861.536C1208.35 863.625 1208.19 865.81 1207.7 867.723C1207.2 869.653 1206.29 871.61 1205.2 873.483C1203.02 877.23 1199.84 881.164 1196.68 884.669C1193.49 888.201 1190.21 891.424 1187.73 893.757C1186.49 894.926 1185.44 895.877 1184.7 896.538C1184.33 896.869 1184.04 897.128 1183.84 897.305C1183.74 897.394 1183.66 897.463 1183.6 897.51L1183.54 897.564L1183.52 897.583C1183.52 897.583 1183.52 897.586 1181.18 894.876L1183.52 897.586L1179.74 900.844L1113.02 735.65ZM1182.57 888.785C1182.66 888.706 1182.74 888.625 1182.83 888.544C1185.22 886.292 1188.36 883.213 1191.37 879.873C1194.41 876.506 1197.21 873 1199.02 869.886C1199.92 868.328 1200.5 866.999 1200.78 865.932C1201.06 864.848 1200.95 864.325 1200.88 864.137C1199.08 859.549 1188.16 830.295 1177.71 802.247C1172.48 788.21 1167.36 774.457 1163.55 764.214C1161.64 759.093 1160.07 754.848 1158.96 751.884L1157.37 747.602C1157.31 747.509 1157.22 747.39 1157.12 747.249C1156.81 746.819 1156.31 746.184 1155.61 745.44C1154.22 743.95 1152.06 742.052 1149.05 740.48C1143.64 737.653 1135.05 735.66 1122.4 739.777L1182.57 888.785ZM1160.58 745.992L1163.93 744.748L1163.82 744.447L1163.66 744.171L1160.58 745.992Z",
    fill: "#9C9C9C"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M1293.74 739.261C1309.06 733.276 1316.62 715.995 1310.62 700.663C1304.63 685.331 1287.36 677.754 1272.04 683.74C1256.73 689.725 1249.17 707.007 1255.16 722.339C1261.16 737.67 1278.43 745.247 1293.74 739.261Z",
    fill: "white"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1273 686.2C1259.05 691.655 1252.16 707.405 1257.62 721.378C1263.08 735.352 1278.82 742.257 1292.78 736.802C1306.74 731.346 1313.63 715.596 1308.17 701.623C1302.7 687.65 1286.96 680.744 1273 686.2ZM1252.71 723.299C1246.18 706.609 1254.41 687.796 1271.08 681.28C1287.75 674.764 1306.56 683.012 1313.08 699.702C1319.6 716.393 1311.38 735.205 1294.7 741.721C1278.03 748.237 1259.23 739.989 1252.71 723.299Z",
    fill: "#9C9C9C"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M1322.04 811.662C1337.35 805.676 1344.91 788.395 1338.92 773.063C1332.93 757.731 1315.65 750.154 1300.34 756.14C1285.03 762.126 1277.47 779.407 1283.46 794.739C1289.45 810.071 1306.73 817.647 1322.04 811.662Z",
    fill: "white"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1301.3 758.6C1287.34 764.055 1280.46 779.805 1285.92 793.778C1291.38 807.752 1307.12 814.657 1321.08 809.202C1335.04 803.747 1341.92 787.997 1336.46 774.023C1331 760.05 1315.26 753.144 1301.3 758.6ZM1281 795.699C1274.48 779.009 1282.71 760.196 1299.38 753.68C1316.05 747.164 1334.85 755.412 1341.38 772.103C1347.9 788.793 1339.67 807.605 1323 814.121C1306.33 820.637 1287.53 812.389 1281 795.699Z",
    fill: "#9C9C9C"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1263.2 706.24C1263.18 706.129 1263.16 705.986 1263.14 705.812C1263.08 705.282 1263.02 704.477 1263.03 703.458C1263.04 701.418 1263.34 698.559 1264.48 695.363C1266.54 689.615 1271.51 682.326 1283.6 676.774L1340.41 827.096C1340.29 827.095 1340.18 827.094 1340.06 827.093C1336.77 827.061 1332.38 826.925 1327.9 826.514C1323.38 826.1 1318.95 825.42 1315.51 824.357C1313.79 823.825 1312.46 823.241 1311.53 822.643C1310.59 822.037 1310.32 821.58 1310.24 821.392C1308.45 816.804 1296.64 787.897 1285.3 760.196C1279.63 746.332 1274.07 732.753 1269.92 722.64C1267.85 717.584 1266.13 713.393 1264.93 710.468L1263.2 706.24ZM1345.56 830.629L1345.69 834.203L1350.67 834.037L1287.69 667.385L1284.32 668.7C1268.02 675.073 1260.75 684.603 1257.76 692.943C1256.29 697.041 1255.9 700.724 1255.88 703.401C1255.87 704.741 1255.95 705.838 1256.04 706.622C1256.09 707.014 1256.13 707.329 1256.17 707.559C1256.19 707.673 1256.21 707.767 1256.22 707.838L1256.24 707.927L1256.25 707.972L1256.25 707.977C1256.25 707.98 1256.25 707.982 1259.74 707.235L1256.25 707.982L1256.32 708.295L1256.44 708.591L1259.74 707.235C1256.44 708.591 1256.44 708.591 1256.44 708.591L1258.32 713.178C1259.52 716.104 1261.24 720.294 1263.31 725.35C1267.45 735.462 1273.02 749.04 1278.69 762.903C1290.05 790.654 1301.82 819.476 1303.59 823.993C1304.4 826.082 1306 827.581 1307.66 828.653C1309.34 829.734 1311.34 830.552 1313.4 831.191C1317.54 832.47 1322.55 833.205 1327.25 833.637C1331.99 834.071 1336.59 834.212 1339.99 834.245C1341.7 834.262 1343.11 834.252 1344.1 834.237C1344.6 834.23 1344.99 834.221 1345.26 834.215C1345.39 834.211 1345.5 834.209 1345.57 834.207L1345.65 834.204L1345.69 834.203C1345.69 834.203 1345.69 834.203 1345.56 830.629Z",
    fill: "#9C9C9C"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1147.75 814.518L659.539 1009.43L657.581 1004.52L1145.79 809.613L1147.75 814.518Z",
    fill: "#9C9C9C"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1146.04 907.083L1084.4 750.685L1089.31 748.751L1150.95 905.148L1146.04 907.083Z",
    fill: "#9C9C9C"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1114.1 919.572L1052.24 763.261L1057.14 761.319L1119 917.63L1114.1 919.572Z",
    fill: "#9C9C9C"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1080.82 932.577L1018.96 776.266L1023.87 774.325L1085.73 930.636L1080.82 932.577Z",
    fill: "#9C9C9C"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1048.88 945.063L987.016 788.752L991.921 786.81L1053.78 943.121L1048.88 945.063Z",
    fill: "#9C9C9C"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1012.05 959.456L950.19 803.145L955.096 801.203L1016.96 957.514L1012.05 959.456Z",
    fill: "#9C9C9C"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M979.887 972.037L947.54 891.236L952.438 889.275L984.785 970.076L979.887 972.037Z",
    fill: "#9C9C9C"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M948.608 984.262L916.26 903.461L921.158 901.5L953.506 982.301L948.608 984.262Z",
    fill: "#9C9C9C"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M914.667 997.528L882.319 916.727L887.217 914.766L919.565 995.567L914.667 997.528Z",
    fill: "#9C9C9C"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M883.163 1009.83L851.037 928.945L855.94 926.998L888.066 1007.89L883.163 1009.83Z",
    fill: "#9C9C9C"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M846.562 1024.15L814.214 943.345L819.113 941.384L851.46 1022.19L846.562 1024.15Z",
    fill: "#9C9C9C"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M815.058 1036.45L782.933 955.563L787.836 953.616L819.962 1034.5L815.058 1036.45Z",
    fill: "#9C9C9C"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M781.342 1049.64L748.994 968.835L753.892 966.875L786.24 1047.68L781.342 1049.64Z",
    fill: "#9C9C9C"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M749.841 1061.95L717.493 981.147L722.391 979.186L754.738 1059.99L749.841 1061.95Z",
    fill: "#9C9C9C"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M715.899 1075.21L683.551 994.413L688.449 992.452L720.797 1073.25L715.899 1075.21Z",
    fill: "#9C9C9C"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M684.398 1087.53L652.05 1006.72L656.948 1004.76L689.296 1085.57L684.398 1087.53Z",
    fill: "#9C9C9C"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M650.454 1100.79L618.328 1019.9L623.232 1017.95L655.357 1098.84L650.454 1100.79Z",
    fill: "#9C9C9C"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M619.177 1113.02L586.83 1032.22L591.728 1030.25L624.075 1111.06L619.177 1113.02Z",
    fill: "#9C9C9C"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M582.349 1127.4L550.224 1046.52L555.127 1044.57L587.253 1125.46L582.349 1127.4Z",
    fill: "#9C9C9C"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M551.073 1139.64L518.725 1058.83L523.623 1056.87L555.971 1137.67L551.073 1139.64Z",
    fill: "#9C9C9C"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M517.132 1152.9L484.784 1072.1L489.682 1070.14L522.03 1150.94L517.132 1152.9Z",
    fill: "#9C9C9C"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M931.796 897.409L902.043 824.554L906.927 822.559L936.68 895.414L931.796 897.409Z",
    fill: "#9C9C9C"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M844.61 931.476L815.079 858.534L819.969 856.554L849.501 929.496L844.61 931.476Z",
    fill: "#9C9C9C"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M754.544 966.677L725.012 893.736L729.903 891.756L759.434 964.697L754.544 966.677Z",
    fill: "#9C9C9C"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M939 1185.48L913 1195.48L942 1266.48L969 1255.98L939 1185.48Z",
    fill: "#E13827"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M1083.5 839.977L1054 851.977L1085 932.977L1115 921.477L1083.5 839.977Z",
    fill: "#E13827"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M884 919.977L857 929.477L888 1007.98L915 998.477L884 919.977Z",
    fill: "#E13827"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M842 1223.48L811 1234.98L840 1305.98L870.5 1293.98L842 1223.48Z",
    fill: "#FF5910"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M1547 950.977L1516 962.477L1545 1033.48L1575.5 1021.48L1547 950.977Z",
    fill: "#FF5910"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M1516.5 878.977L1487 890.477L1513 956.477L1543.5 944.477L1516.5 878.977Z",
    fill: "#FF5910"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M1616.5 639.977L1587 651.477L1615 720.477L1643.5 709.477L1616.5 639.977Z",
    fill: "#FF5910"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M777 1248.98L746 1261.48L775 1332.48L805.5 1320.48L777 1248.98Z",
    fill: "#E13827"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M813 1443.98L781 1456.98L808.5 1523.98L840 1511.48L813 1443.98Z",
    fill: "#E13827"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M844 1715.98L812 1728.98L839.5 1795.98L871 1783.48L844 1715.98Z",
    fill: "#E13827"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M941 1762.98L909 1775.98L936.5 1842.98L968 1830.48L941 1762.98Z",
    fill: "#E13827"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M1042 1722.98L1010 1735.98L1037.5 1802.98L1069 1790.48L1042 1722.98Z",
    fill: "#E13827"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M1143 1682.98L1111 1695.98L1138.5 1762.98L1170 1750.48L1143 1682.98Z",
    fill: "#E13827"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M1244 1642.98L1212 1655.98L1239.5 1722.98L1271 1710.48L1244 1642.98Z",
    fill: "#E13827"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M1341 1604.98L1309 1617.98L1336.5 1684.98L1368 1672.48L1341 1604.98Z",
    fill: "#E13827"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M2290.5 1434.48L2256.5 1447.98L2281.5 1507.98L2315 1495.48L2290.5 1434.48Z",
    fill: "#E13827"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M2358.5 1405.98L2324.5 1419.48L2350 1481.48L2383.5 1468.98L2358.5 1405.98Z",
    fill: "#E13827"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M2499 1351.98L2465 1365.48L2490.5 1427.48L2524 1414.98L2499 1351.98Z",
    fill: "#E13827"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M2711 1268.98L2677 1282.48L2702.5 1344.48L2737.5 1329.98L2711 1268.98Z",
    fill: "#E13827"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M1438 1566.98L1406 1579.98L1433.5 1646.98L1465 1634.48L1438 1566.98Z",
    fill: "#E13827"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M1535 1528.98L1503 1541.98L1530.5 1608.98L1562 1596.48L1535 1528.98Z",
    fill: "#E13827"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 548,
    y: 2290.58,
    width: 454.149,
    height: 118,
    rx: 10,
    transform: "rotate(-20.9769 548 2290.58)",
    fill: "#FE763B"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M620.408 2349.03L608 2318.74L616.222 2315.37L625.915 2339.03L638.159 2334.02L640.873 2340.64L620.408 2349.03Z",
    fill: "white"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M655.427 2335.16C652.962 2336.17 650.653 2336.55 648.498 2336.29C646.34 2336.02 644.432 2335.21 642.777 2333.83C641.118 2332.45 639.811 2330.6 638.858 2328.27C637.905 2325.95 637.537 2323.71 637.755 2321.58C637.968 2319.43 638.752 2317.51 640.107 2315.81C641.458 2314.11 643.366 2312.75 645.83 2311.74C648.295 2310.73 650.606 2310.36 652.765 2310.63C654.92 2310.88 656.827 2311.7 658.486 2313.08C660.142 2314.45 661.446 2316.3 662.399 2318.63C663.352 2320.96 663.722 2323.19 663.509 2325.34C663.291 2327.48 662.507 2329.4 661.156 2331.11C659.801 2332.8 657.891 2334.15 655.427 2335.16ZM653.014 2329.11C653.704 2328.82 654.206 2328.35 654.519 2327.68C654.832 2327.01 654.95 2326.19 654.875 2325.22C654.8 2324.25 654.52 2323.17 654.035 2321.99C653.546 2320.79 652.99 2319.83 652.367 2319.1C651.739 2318.35 651.079 2317.85 650.387 2317.59C649.694 2317.34 649.003 2317.35 648.313 2317.63C647.583 2317.93 647.052 2318.42 646.72 2319.09C646.387 2319.77 646.258 2320.6 646.334 2321.57C646.405 2322.53 646.685 2323.6 647.174 2324.8C647.658 2325.98 648.214 2326.94 648.842 2327.69C649.469 2328.43 650.139 2328.93 650.851 2329.18C651.564 2329.43 652.285 2329.4 653.014 2329.11Z",
    fill: "white"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M674.579 2300.31L677.003 2306.22L662.038 2312.35L659.615 2306.44L674.579 2300.31ZM660.284 2299.81L668.446 2296.46L676.988 2317.31C677.118 2317.63 677.281 2317.87 677.478 2318.05C677.672 2318.21 677.904 2318.3 678.175 2318.31C678.442 2318.32 678.753 2318.25 679.108 2318.1C679.354 2318 679.628 2317.86 679.929 2317.66C680.24 2317.47 680.466 2317.32 680.608 2317.21L684.142 2322.47C683.821 2322.72 683.353 2323.07 682.738 2323.51C682.132 2323.94 681.376 2324.37 680.47 2324.8C678.637 2325.67 676.986 2326.12 675.516 2326.15C674.042 2326.18 672.769 2325.8 671.696 2325.01C670.623 2324.22 669.772 2323.02 669.141 2321.43L660.284 2299.81Z",
    fill: "white"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M706.748 2289.96C706.406 2289.49 706.016 2289.11 705.578 2288.83C705.137 2288.54 704.652 2288.34 704.125 2288.24C703.604 2288.12 703.044 2288.1 702.445 2288.18C701.852 2288.25 701.235 2288.42 700.595 2288.68C699.214 2289.25 698.172 2290.06 697.466 2291.12C696.771 2292.18 696.421 2293.43 696.418 2294.88C696.424 2296.33 696.786 2297.93 697.505 2299.69C698.232 2301.46 699.096 2302.88 700.096 2303.94C701.096 2305.01 702.211 2305.68 703.442 2305.96C704.673 2306.24 705.998 2306.09 707.418 2305.5C708.67 2304.99 709.635 2304.38 710.314 2303.68C711.002 2302.97 711.416 2302.2 711.556 2301.36C711.695 2300.52 711.579 2299.64 711.207 2298.74L712.687 2298.3L705.767 2301.14L703.368 2295.28L716.795 2289.78L718.515 2293.98C719.646 2296.74 720.027 2299.34 719.658 2301.78C719.294 2304.21 718.301 2306.37 716.679 2308.25C715.062 2310.13 712.933 2311.6 710.291 2312.68C707.343 2313.89 704.499 2314.33 701.758 2313.99C699.017 2313.65 696.546 2312.58 694.345 2310.77C692.154 2308.97 690.404 2306.46 689.095 2303.27C688.07 2300.77 687.54 2298.39 687.508 2296.15C687.485 2293.9 687.881 2291.83 688.696 2289.95C689.508 2288.05 690.666 2286.39 692.172 2284.98C693.673 2283.56 695.444 2282.43 697.485 2281.6C699.279 2280.86 701.05 2280.44 702.798 2280.32C704.552 2280.19 706.212 2280.35 707.779 2280.8C709.351 2281.24 710.763 2281.94 712.013 2282.91C713.264 2283.89 714.279 2285.1 715.058 2286.55L706.748 2289.96Z",
    fill: "white"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M735.855 2301.73L723.447 2271.44L736.519 2266.09C738.767 2265.17 740.915 2264.8 742.964 2265C745.013 2265.2 746.836 2265.91 748.43 2267.13C750.025 2268.35 751.263 2270.04 752.143 2272.19C753.032 2274.36 753.318 2276.43 753.003 2278.42C752.697 2280.4 751.852 2282.17 750.468 2283.74C749.094 2285.3 747.254 2286.56 744.947 2287.5L737.14 2290.7L734.522 2284.31L740.674 2281.79C741.64 2281.4 742.394 2280.89 742.937 2280.28C743.486 2279.65 743.814 2278.95 743.92 2278.17C744.036 2277.38 743.918 2276.56 743.567 2275.7C743.211 2274.84 742.721 2274.17 742.096 2273.72C741.477 2273.24 740.756 2272.99 739.932 2272.94C739.115 2272.89 738.223 2273.06 737.257 2273.45L734.359 2274.64L744.076 2298.36L735.855 2301.73Z",
    fill: "white"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M763.3 2290.48L753.994 2267.77L761.92 2264.52L763.689 2268.84L763.925 2268.74C763.685 2266.98 763.862 2265.54 764.456 2264.43C765.06 2263.32 765.969 2262.52 767.181 2262.02C767.536 2261.88 767.898 2261.76 768.267 2261.68C768.643 2261.58 769.013 2261.52 769.379 2261.48L772.232 2268.45C771.771 2268.48 771.231 2268.58 770.611 2268.75C769.992 2268.92 769.47 2269.1 769.046 2269.27C768.247 2269.6 767.602 2270.08 767.111 2270.7C766.626 2271.32 766.334 2272.02 766.236 2272.82C766.133 2273.61 766.26 2274.44 766.615 2275.31L771.462 2287.14L763.3 2290.48Z",
    fill: "white"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M791.106 2279.57C788.681 2280.57 786.402 2280.96 784.267 2280.75C782.139 2280.53 780.244 2279.74 778.582 2278.38C776.927 2277.01 775.598 2275.11 774.597 2272.66C773.636 2270.31 773.269 2268.07 773.496 2265.93C773.723 2263.79 774.5 2261.87 775.825 2260.19C777.151 2258.51 778.986 2257.19 781.333 2256.22C783.048 2255.52 784.71 2255.15 786.318 2255.11C787.926 2255.08 789.431 2255.36 790.833 2255.98C792.23 2256.58 793.49 2257.49 794.612 2258.71C795.734 2259.93 796.665 2261.44 797.404 2263.25L798.179 2265.14L777.891 2273.45L776.05 2268.96L788.826 2263.72C788.549 2263.08 788.147 2262.57 787.62 2262.21C787.099 2261.84 786.51 2261.63 785.855 2261.57C785.206 2261.5 784.541 2261.61 783.861 2261.89C783.2 2262.16 782.652 2262.55 782.217 2263.06C781.779 2263.56 781.492 2264.13 781.359 2264.76C781.236 2265.39 781.3 2266.03 781.55 2266.7L783.538 2271.55C783.837 2272.28 784.256 2272.87 784.796 2273.32C785.336 2273.76 785.958 2274.03 786.663 2274.12C787.368 2274.22 788.125 2274.1 788.933 2273.76C789.495 2273.53 789.975 2273.24 790.374 2272.9C790.783 2272.55 791.094 2272.15 791.308 2271.72C791.518 2271.28 791.615 2270.81 791.599 2270.32L799.052 2267.27C799.442 2268.95 799.397 2270.57 798.917 2272.13C798.434 2273.67 797.534 2275.09 796.22 2276.37C794.911 2277.65 793.206 2278.71 791.106 2279.57Z",
    fill: "white"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M809.686 2244.95L812.109 2250.87L796.908 2257.1L794.485 2251.18L809.686 2244.95ZM806.689 2272.71L797.117 2249.34C796.349 2247.47 796.048 2245.78 796.214 2244.27C796.379 2242.77 796.948 2241.46 797.92 2240.34C798.892 2239.23 800.206 2238.34 801.862 2237.66C802.897 2237.23 803.935 2236.9 804.976 2236.66C806.026 2236.41 806.812 2236.25 807.334 2236.18L808.55 2242.52C808.218 2242.55 807.845 2242.62 807.43 2242.73C807.011 2242.84 806.654 2242.95 806.359 2243.07C805.59 2243.38 805.139 2243.76 805.006 2244.19C804.873 2244.63 804.916 2245.11 805.134 2245.64L814.851 2269.36L806.689 2272.71Z",
    fill: "white"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M832.503 2262.61C830.078 2263.61 827.798 2264 825.664 2263.79C823.535 2263.57 821.64 2262.78 819.979 2261.42C818.324 2260.05 816.995 2258.15 815.993 2255.7C815.032 2253.35 814.665 2251.11 814.893 2248.97C815.12 2246.82 815.897 2244.91 817.222 2243.23C818.547 2241.55 820.383 2240.22 822.729 2239.26C824.444 2238.56 826.106 2238.19 827.714 2238.15C829.322 2238.12 830.827 2238.4 832.229 2239.02C833.627 2239.62 834.887 2240.53 836.009 2241.75C837.131 2242.97 838.061 2244.48 838.801 2246.29L839.576 2248.18L819.288 2256.49L817.446 2252L830.222 2246.76C829.946 2246.12 829.544 2245.61 829.017 2245.25C828.495 2244.88 827.907 2244.67 827.252 2244.61C826.602 2244.54 825.937 2244.65 825.257 2244.93C824.597 2245.2 824.049 2245.59 823.614 2246.1C823.175 2246.6 822.889 2247.17 822.756 2247.8C822.632 2248.43 822.696 2249.07 822.947 2249.74L824.934 2254.59C825.233 2255.32 825.653 2255.91 826.192 2256.36C826.732 2256.8 827.355 2257.07 828.06 2257.16C828.765 2257.25 829.522 2257.13 830.33 2256.8C830.892 2256.57 831.372 2256.28 831.771 2255.94C832.179 2255.59 832.491 2255.19 832.705 2254.76C832.915 2254.32 833.012 2253.85 832.996 2253.36L840.448 2250.31C840.838 2251.99 840.794 2253.61 840.314 2255.17C839.83 2256.71 838.931 2258.13 837.616 2259.41C836.307 2260.69 834.603 2261.75 832.503 2262.61Z",
    fill: "white"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M846.784 2256.28L837.479 2233.57L845.404 2230.32L847.174 2234.64L847.41 2234.54C847.17 2232.77 847.347 2231.34 847.941 2230.23C848.545 2229.12 849.453 2228.31 850.666 2227.82C851.021 2227.67 851.383 2227.56 851.752 2227.48C852.127 2227.38 852.498 2227.31 852.863 2227.28L855.717 2234.24C855.256 2234.27 854.716 2234.37 854.096 2234.55C853.476 2234.72 852.954 2234.89 852.531 2235.07C851.732 2235.39 851.087 2235.87 850.596 2236.5C850.11 2237.11 849.818 2237.82 849.72 2238.62C849.618 2239.41 849.745 2240.24 850.1 2241.11L854.947 2252.93L846.784 2256.28Z",
    fill: "white"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M864.839 2248.88L855.534 2226.17L863.46 2222.92L865.229 2227.24L865.465 2227.14C865.225 2225.38 865.402 2223.94 865.996 2222.83C866.6 2221.72 867.508 2220.92 868.721 2220.42C869.076 2220.28 869.438 2220.16 869.807 2220.08C870.182 2219.98 870.553 2219.92 870.918 2219.88L873.772 2226.85C873.311 2226.88 872.771 2226.98 872.151 2227.15C871.531 2227.32 871.01 2227.5 870.586 2227.67C869.787 2228 869.142 2228.47 868.651 2229.1C868.165 2229.71 867.874 2230.42 867.775 2231.22C867.673 2232.01 867.8 2232.84 868.155 2233.71L873.002 2245.54L864.839 2248.88Z",
    fill: "white"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M892.646 2237.97C890.221 2238.97 887.941 2239.36 885.807 2239.15C883.678 2238.93 881.783 2238.14 880.122 2236.78C878.467 2235.41 877.138 2233.5 876.137 2231.06C875.175 2228.71 874.808 2226.47 875.036 2224.33C875.263 2222.18 876.04 2220.27 877.365 2218.59C878.69 2216.91 880.526 2215.58 882.872 2214.62C884.588 2213.92 886.249 2213.55 887.857 2213.51C889.465 2213.48 890.97 2213.76 892.372 2214.37C893.77 2214.98 895.03 2215.89 896.152 2217.11C897.274 2218.33 898.205 2219.84 898.944 2221.65L899.719 2223.54L879.431 2231.85L877.589 2227.36L890.366 2222.12C890.089 2221.47 889.687 2220.97 889.16 2220.61C888.639 2220.24 888.05 2220.02 887.395 2219.97C886.745 2219.9 886.081 2220.01 885.4 2220.29C884.74 2220.56 884.192 2220.95 883.757 2221.46C883.318 2221.96 883.032 2222.53 882.899 2223.16C882.776 2223.79 882.839 2224.43 883.09 2225.1L885.077 2229.95C885.376 2230.68 885.796 2231.27 886.335 2231.72C886.875 2232.16 887.498 2232.43 888.203 2232.52C888.908 2232.61 889.665 2232.49 890.473 2232.16C891.035 2231.93 891.515 2231.64 891.914 2231.3C892.322 2230.94 892.634 2230.55 892.848 2230.12C893.058 2229.68 893.155 2229.21 893.139 2228.72L900.592 2225.67C900.981 2227.35 900.937 2228.97 900.457 2230.52C899.973 2232.07 899.074 2233.49 897.759 2234.77C896.45 2236.05 894.746 2237.11 892.646 2237.97Z",
    fill: "white"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M915.27 2228.57C913.653 2229.23 911.991 2229.41 910.283 2229.12C908.585 2228.83 906.974 2227.99 905.449 2226.6C903.934 2225.2 902.639 2223.19 901.565 2220.57C900.442 2217.83 899.953 2215.43 900.098 2213.37C900.253 2211.3 900.842 2209.59 901.865 2208.24C902.899 2206.88 904.165 2205.9 905.663 2205.29C906.787 2204.82 907.853 2204.62 908.863 2204.67C909.868 2204.7 910.79 2204.93 911.628 2205.35C912.463 2205.75 913.185 2206.28 913.796 2206.93L913.914 2206.88L909.189 2195.34L917.351 2192L929.759 2222.28L921.655 2225.6L920.129 2221.88L919.951 2221.95C919.951 2222.85 919.78 2223.72 919.439 2224.58C919.104 2225.42 918.59 2226.19 917.897 2226.88C917.21 2227.57 916.335 2228.13 915.27 2228.57ZM915.718 2221.06C916.467 2220.75 917.019 2220.27 917.374 2219.62C917.734 2218.96 917.894 2218.17 917.852 2217.25C917.817 2216.32 917.573 2215.3 917.121 2214.2C916.66 2213.08 916.119 2212.17 915.496 2211.5C914.879 2210.81 914.212 2210.36 913.496 2210.16C912.786 2209.94 912.057 2209.99 911.307 2210.29C910.558 2210.6 910.006 2211.08 909.652 2211.73C909.303 2212.37 909.151 2213.15 909.196 2214.08C909.248 2214.99 909.503 2216.01 909.964 2217.13C910.424 2218.26 910.958 2219.16 911.565 2219.86C912.178 2220.54 912.835 2220.99 913.535 2221.21C914.241 2221.42 914.969 2221.37 915.718 2221.06Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLotG);
export default __webpack_public_path__ + "static/media/LotG.3220dddac25662b790d7666161c0f611.svg";
export { ForwardRef as ReactComponent };